(function () {
  "use strict";

  const MEERA_API = "/apps/meera";
  const MEERA_FIT_API = "https://meera-v1.onrender.com/fit/recommend";

  async function meeraReadResponse(response) {
    const raw = await response.text();
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (error) {
      return { ok: false, error: raw.trim().slice(0, 500), non_json_response: true };
    }
  }

  const SESSION_KEY = "meera_session_id";

  function getSessionId() {
    let sessionId = sessionStorage.getItem(SESSION_KEY);

    if (!sessionId) {
      sessionId =
        "shopify-" +
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).substring(2, 10);

      sessionStorage.setItem(SESSION_KEY, sessionId);
    }

    return sessionId;
  }

  // ------------------------------------------------------------------
  // Attribution: lets the store tell Meera-assisted orders from the rest.
  // Once Meera has shown products, the Shopify cart is tagged with the
  // chat session id (it appears on the order as "Additional details").
  // Clicks and cart contents are logged against the same session id.
  // Everything here is best-effort and never blocks the chat.
  // ------------------------------------------------------------------
  const ASSIST_KEY = "meera_assisted";

  function meeraTrack(type, handle) {
    try {
      fetch(MEERA_API + "/event", {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: getSessionId(),
          event_type: type,
          product_handle: handle || null
        })
      }).catch(function () {});
    } catch (e) {}
  }

  function meeraTagCart() {
    try {
      sessionStorage.setItem(ASSIST_KEY, "1");
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            meera_session: getSessionId(),
            meera_assisted: "yes"
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }

  function meeraCartCheck() {
    // On each page load in an assisted session: make sure the cart still
    // carries the tag (a new cart starts after checkout) and log which
    // products are in it.
    try {
      if (sessionStorage.getItem(ASSIST_KEY) !== "1") return;
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          const attrs = cart.attributes || {};
          if (attrs.meera_session !== getSessionId() && cart.item_count > 0) {
            meeraTagCart();
          }
          const seenKey = "meera_cart_seen";
          let seen = [];
          try { seen = JSON.parse(sessionStorage.getItem(seenKey) || "[]"); } catch (e) {}
          (cart.items || []).forEach(function (item) {
            const handle = item.handle || "";
            if (handle && seen.indexOf(handle) === -1) {
              seen.push(handle);
              meeraTrack("cart_seen", handle);
            }
          });
          sessionStorage.setItem(seenKey, JSON.stringify(seen.slice(-50)));
        })
        .catch(function () {});
    } catch (e) {}
  }

  document.addEventListener("click", function (event) {
    try {
      const link = event.target.closest && event.target.closest(".meera-product-link");
      if (link) {
        const m = (link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
        meeraTrack("product_click", m ? m[1] : null);
        meeraTagCart();
        return;
      }
      const tryon = event.target.closest && event.target.closest(".meera-tryon-button");
      if (tryon) {
        meeraTrack("tryon_click", tryon.getAttribute("data-product-handle"));
      }
    } catch (e) {}
  }, true);

  setTimeout(meeraCartCheck, 1500);

  function escapeHtml(value) {
    const div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function formatPrice(price) {
    if (price == null || price === "") {
      return "";
    }

    const number = Number(price);

    if (Number.isNaN(number)) {
      return String(price);
    }

    return "₹" + number.toLocaleString("en-IN");
  }

  function createWidget() {
    if (document.getElementById("meera-widget")) {
      return;
    }

    const root = document.createElement("div");
    root.id = "meera-widget";

    root.innerHTML = `
      <style>
        #meera-widget {
          font-family: Arial, Helvetica, sans-serif;
          position: relative;
          right: auto;
          bottom: auto;
          z-index: 999999;
          display: flex;
          align-items: center;
        }

        #meera-widget-button {
            width: auto;
            height: auto;
            min-height: 0;
            padding: 0 4px;
            border: none;
            background: transparent;
            color: #222;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 5px;
            box-shadow: none;
        }

        .meera-button-icon {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            object-fit: cover;
            display: block;
            border: 2px solid #d8c28f;
            box-shadow: 0 4px 12px rgba(0,0,0,0.18);
            }

            .meera-button-label {
            display: inline-block;
            background: #d8c28f;
            color: #222;
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 10px;
            font-weight: 600;
            line-height: 1.2;
            white-space: nowrap;
        }

        #meera-widget-panel {
          display: none;
          position: absolute;
          right: 0;
          top: 48px;
          width: 380px;
          max-width: calc(100vw - 32px);
          height: 620px;
          max-height: calc(100vh - 110px);
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 8px 35px rgba(0,0,0,0.2);
        }

        #meera-widget-panel.meera-maximized {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100vw;
          max-width: none;
          height: 100vh;
          max-height: none;
          border-radius: 0;
          border: none;
        }

        #meera-widget-header {
         padding: 16px;
         background: #d8c28f;
         color: #222;
         display: flex;
         align-items: center;
         justify-content: space-between;
        }

        .meera-header-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .meera-header-icon {
         width: 36px;
         height: 36px;
         border-radius: 50%;
         object-fit: cover;
        }

        #meera-widget-header strong {
          font-size: 16px;
        }

        #meera-widget-close {
          background: transparent;
          border: none;
          color: #fff;
          cursor: pointer;
          font-size: 20px;
        }

        #meera-widget-maximize {
          background: transparent;
          border: none;
          color: #fff;
          cursor: pointer;
          font-size: 18px;
          margin-right: 8px;
        }

        #meera-widget-room {
          background: transparent;
          border: none;
          color: #fff;
          cursor: pointer;
          font-size: 18px;
          margin-right: 8px;
        }

        #meera-room-panel {
          position: absolute;
          inset: 0;
          z-index: 20;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.35);
        }

        .meera-room-box {
          width: min(420px, 90%);
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
          overflow: hidden;
        }

        .meera-room-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 16px;
          background: #dcc58f;
          color: #222;
        }

        .meera-room-header button {
          border: none;
          background: transparent;
          font-size: 22px;
          cursor: pointer;
        }

        .meera-room-content {
          padding: 20px;
        }

        .meera-room-section {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .meera-room-title {
          font-size: 18px;
          font-weight: 600;
        }

        .meera-room-description {
          font-size: 13px;
          line-height: 1.5;
          color: #666;
          margin-bottom: 6px;
        }

                /* ================================
           SHOPPING ROOM
           ================================ */

        #meera-shopping-room {
          position: absolute;
          inset: 0;
          z-index: 30;
          display: flex;
          align-items: stretch;
          justify-content: center;
          background: #fff;
        }

        /* Optional full-screen workspace for group shopping. */
        #meera-shopping-room.meera-room-maximized {
          position: fixed !important;
          inset: 0 !important;
          width: 100vw !important;
          height: 100dvh !important;
          max-height: none !important;
          z-index: 2147483000 !important;
          background: #fff;
        }

        #meera-shopping-room.meera-room-maximized .meera-shopping-room-box {
          width: 100%;
          height: 100%;
          max-width: none;
          border-radius: 0;
        }

        #meera-shopping-room.meera-room-maximized .meera-room-product img {
          width: 100%;
          height: 260px !important;
          max-height: 260px !important;
          object-fit: contain !important;
        }

        .meera-shopping-room-box {
          width: 100%;
          height: 100%;
          background: #fff;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .meera-shopping-room-header {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 16px;
          background: #dcc58f;
          color: #222;
        }

        .meera-shopping-room-header strong {
          font-size: 18px;
        }

        .meera-shopping-room-header-main {
          display: flex;
          flex-direction: column;
          gap: 7px;
          min-width: 0;
        }

        .meera-shopping-room-code-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 7px;
        }

        .meera-shopping-room-code {
          display: inline-block !important;
          visibility: visible !important;
          opacity: 1 !important;
          margin-top: 0;
          padding: 5px 9px;
          border: 1px solid rgba(34, 34, 34, 0.22);
          border-radius: 7px;
          background: #fffaf0;
          color: #222 !important;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.06em;
          line-height: 1.3;
        }

        .meera-shopping-room-header-actions {
          display: flex;
          align-items: center;
          gap: 7px;
          flex-shrink: 0;
        }

        .meera-shopping-room-header .meera-room-header-action {
          border: 1px solid rgba(34, 34, 34, 0.25);
          border-radius: 7px;
          padding: 7px 9px;
          background: #fffaf0;
          color: #222;
          font-size: 12px;
          line-height: 1.2;
          white-space: nowrap;
        }

        .meera-shopping-room-header .meera-room-header-action:hover {
          background: #fff;
        }

        @media (max-width: 420px) {
          .meera-shopping-room-header {
            padding: 10px;
            gap: 6px;
          }
          .meera-shopping-room-header strong {
            font-size: 15px;
          }
          .meera-shopping-room-header-actions {
            gap: 4px;
          }
          .meera-shopping-room-header .meera-room-header-action {
            padding: 6px;
            font-size: 11px;
          }
        }

        .meera-shopping-room-header button {
          border: none;
          background: transparent;
          font-size: 24px;
          cursor: pointer;
          color: #222;
        }

        .meera-shopping-room-participants {
          flex-shrink: 0;
          padding: 10px 14px;
          border-bottom: 1px solid #e5e5e5;
          background: #fafafa;
          font-size: 13px;
        }

        #meera-shopping-participants {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 7px;
        }

        .meera-room-person {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 14px;
          background: #eee7d5;
          font-size: 12px;
        }

        .meera-shopping-transcript {
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          padding: 14px;
          background: #fff;
        }

        .meera-room-message {
          margin-bottom: 12px;
          padding: 9px 11px;
          border-radius: 10px;
          max-width: 88%;
          background: #f4f4f4;
        }

        .meera-room-message-meera {
          background: #f1ead8;
        }

        .meera-room-message-system {
          background: transparent;
          color: #777;
          font-size: 12px;
          text-align: center;
          max-width: 100%;
        }

        .meera-room-message-who {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 3px;
        }

        .meera-room-message-text {
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          word-break: break-word;
        }

        /* In the small, docked room, stack content to prevent clipping.
           The maximized workspace keeps the side-by-side product layout. */
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product {
          grid-template-columns: minmax(0, 1fr);
          row-gap: 8px;
        }
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product > img {
          grid-column: 1;
          grid-row: auto;
          width: 100%;
          height: 150px !important;
          max-height: 150px !important;
          object-fit: contain !important;
          object-position: center;
        }
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product-name,
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product-meta,
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product .meera-room-reactions,
        #meera-shopping-room:not(.meera-room-maximized) .meera-room-product > div:not(.meera-room-product-name):not(.meera-room-product-meta) {
          grid-column: 1;
        }

        /* Compact side-by-side product card: image on the left, details/actions on the right. */
        .meera-room-product {
          display: grid;
          grid-template-columns: minmax(150px, 220px) minmax(0, 1fr);
          align-items: start;
          column-gap: 14px;
          margin-top: 8px;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 10px;
          overflow: hidden;
          background: #fff;
        }

        .meera-room-product > img {
          grid-column: 1;
          grid-row: 1 / span 10;
          display: block;
          width: 100%;
          height: 260px !important;
          max-height: 260px !important;
          object-fit: contain !important;
          object-position: center top;
          border-radius: 7px;
          background: #f7f4ed;
        }

        .meera-room-product-name,
        .meera-room-product-meta,
        .meera-room-product .meera-room-reactions,
        .meera-room-product > div:not(.meera-room-product-name):not(.meera-room-product-meta) {
          grid-column: 2;
          min-width: 0;
        }

        .meera-room-product-name {
          padding: 2px 0 7px;
          font-size: 15px;
          font-weight: 700;
          line-height: 1.35;
        }

        .meera-room-product-meta {
          padding: 0 0 8px;
          color: #444;
          font-size: 12px;
          line-height: 1.45;
          overflow-wrap: anywhere;
        }

        .meera-room-product-meta div { margin-bottom: 4px; }
        .meera-room-product-meta strong { color: #6a4e2e; }

        .meera-room-product > div[style*="padding:10px"] img {
          display: block;
          width: auto !important;
          max-width: 100% !important;
          height: auto !important;
          max-height: 220px !important;
          object-fit: contain !important;
          object-position: left top;
        }

        @media (max-width: 620px) {
          .meera-room-product {
            grid-template-columns: minmax(0, 1fr);
            row-gap: 8px;
          }
          .meera-room-product > img {
            grid-column: 1;
            grid-row: auto;
            height: 220px !important;
            max-height: 220px !important;
          }
          .meera-room-product-name,
          .meera-room-product-meta,
          .meera-room-product .meera-room-reactions,
          .meera-room-product > div:not(.meera-room-product-name):not(.meera-room-product-meta) {
            grid-column: 1;
          }
        }

        .meera-shopping-room-input {
          flex-shrink: 0;
          padding: 10px;
          border-top: 1px solid #ddd;
          background: #fafafa;
        }

        .meera-shopping-room-input textarea {
          display: block;
          width: 100%;
          height: 70px;
          box-sizing: border-box;
          resize: none;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 10px;
          font-family: inherit;
          font-size: 14px;
          background: #fff;
        }

        .meera-shopping-room-actions {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          margin-top: 8px;
        }

        .meera-room-meera-toggle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          min-height: 42px;
          padding: 7px 13px;
          border: 1px solid #b8a77d;
          border-radius: 10px;
          background: #fffaf0;
          color: #222;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          user-select: none;
          box-sizing: border-box;
        }

        .meera-room-meera-toggle input[type="checkbox"] {
          appearance: none !important;
          -webkit-appearance: none !important;
          display: inline-grid !important;
          place-content: center !important;
          flex: 0 0 23px !important;
          width: 23px !important;
          height: 23px !important;
          min-width: 23px !important;
          max-width: 23px !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 2px solid #6f6249 !important;
          border-radius: 5px !important;
          background: #ffffff !important;
          box-shadow: none !important;
          cursor: pointer;
        }

        .meera-room-meera-toggle input[type="checkbox"]::before {
          content: "";
          width: 11px;
          height: 6px;
          border-left: 3px solid #ffffff;
          border-bottom: 3px solid #ffffff;
          transform: rotate(-45deg) scale(0);
          transform-origin: center;
        }

        .meera-room-meera-toggle input[type="checkbox"]:checked {
          background: #6a4e2e !important;
          border-color: #6a4e2e !important;
        }

        .meera-room-meera-toggle input[type="checkbox"]:checked::before {
          transform: rotate(-45deg) scale(1);
        }

        .meera-room-meera-toggle:has(input:checked) {
          background: #e7d6a8;
          border-color: #806b3f;
          box-shadow: inset 0 0 0 1px #806b3f;
        }

        #meera-shopping-room.meera-room-maximized .meera-room-meera-toggle {
          min-height: 48px;
          font-size: 15px;
          padding: 9px 16px;
        }

        #meera-shopping-room.meera-room-maximized .meera-room-meera-toggle input[type="checkbox"] {
          flex-basis: 26px !important;
          width: 26px !important;
          height: 26px !important;
          min-width: 26px !important;
          max-width: 26px !important;
        }

        #meera-shopping-send {
          border: none;
          border-radius: 7px;
          padding: 8px 18px;
          background: #222;
          color: #fff;
          cursor: pointer;
        }

        #meera-shopping-send:disabled {
          opacity: 0.5;
          cursor: default;
        }

        .meera-room-section input {
          width: 100%;
          box-sizing: border-box;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 14px;
        }

        .meera-room-section button {
          padding: 10px;
          border: 1px solid #222;
          border-radius: 6px;
          background: #222;
          color: #fff;
          cursor: pointer;
          font-size: 14px;
        }

        .meera-room-divider {
          text-align: center;
          margin: 18px 0;
          color: #888;
          font-size: 13px;
        }

        #meera-widget-messages {
          height: calc(100% - 125px);
          overflow-y: auto;
          padding: 14px;
          background: #fafafa;
        }

        .meera-message {
          margin-bottom: 12px;
          line-height: 1.45;
          font-size: 14px;
        }

        .meera-user {
          text-align: right;
        }

        .meera-user span,
        .meera-assistant span {
          display: inline-block;
          padding: 10px 12px;
          border-radius: 12px;
          max-width: 85%;
        }

        .meera-user span {
          background: #222;
          color: #fff;
        }

        .meera-assistant span {
          background: #fff;
          border: 1px solid #ddd;
          color: #222;
        }

        .meera-products {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 10px;
        }

        .meera-product {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 10px;
          overflow: hidden;
        }

        .meera-product img {
          width: 100%;
          height: auto;
          max-height: 420px;
          object-fit: contain;
          background: #f7f4ed;
          display: block;
        }

        #meera-widget-panel.meera-maximized .meera-products {
          gap: 18px;
          margin-top: 18px;
        }

        #meera-widget-panel.meera-maximized .meera-product {
          display: grid;
          grid-template-columns: minmax(360px, 1fr) minmax(360px, 1fr);
          align-items: stretch;
          min-height: 520px;
          border-radius: 14px;
        }

        #meera-widget-panel.meera-maximized .meera-product > img {
          width: 100%;
          height: 100%;
          min-height: 520px;
          max-height: 720px;
          object-fit: contain;
          background: #f7f4ed;
        }

        #meera-widget-panel.meera-maximized .meera-product-body {
          padding: 28px 30px;
          overflow-y: auto;
        }

        .meera-product-details {
          display: none;
        }

        #meera-widget-panel.meera-maximized .meera-product-details {
          display: block;
          margin-top: 22px;
          color: #333;
        }

        .meera-detail-section {
          margin-top: 18px;
          padding-top: 16px;
          border-top: 1px solid #e6e0d5;
        }

        .meera-detail-title {
          margin-bottom: 7px;
          color: #6a4e2e;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .meera-detail-text {
          font-size: 14px;
          line-height: 1.6;
          color: #444;
        }

        .meera-detail-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px 18px;
          margin-top: 16px;
        }

        .meera-detail-item {
          padding: 10px 12px;
          background: #f8f5ee;
          border: 1px solid #e7dfd2;
          border-radius: 8px;
        }

        .meera-detail-label {
          display: block;
          margin-bottom: 3px;
          color: #777;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: .05em;
        }

        .meera-detail-value {
          font-size: 13px;
          line-height: 1.4;
        }

        .meera-reason-box {
          padding: 13px 14px;
          background: #fbf7ef;
          border-left: 3px solid #d8c28f;
          border-radius: 7px;
        }

        @media (max-width: 800px) {
          #meera-widget-panel.meera-maximized .meera-product {
            grid-template-columns: 1fr;
          }

          #meera-widget-panel.meera-maximized .meera-product > img {
            min-height: 360px;
            max-height: 520px;
          }

          #meera-widget-panel.meera-maximized .meera-product-body {
            padding: 20px;
          }
        }

        .meera-product-body {
          padding: 10px;
        }

        .meera-product-name {
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 5px;
        }

        .meera-product-price {
          font-size: 14px;
          margin-bottom: 8px;
        }

        .meera-product-link {
          display: inline-block;
          text-decoration: none;
          font-size: 13px;
          color: #222;
          border-bottom: 1px solid #222;
        }

        .meera-tryon-button {
          display: inline-block;
          margin-left: 10px;
          padding: 5px 9px;
          border: 1px solid #222;
          border-radius: 4px;
          background: #fff;
          color: #222;
          font-size: 12px;
          cursor: pointer;
        }

        .meera-tryon-button:hover {
          background: #f5f1e8;
        }

        .meera-style-box {
          margin-top: 14px;
          padding: 12px;
          background: #f8f5ee;
          border: 1px solid #e2ddd2;
          border-radius: 8px;
        }

        .meera-style-title {
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 10px;
          color: #222;
        }

        .meera-style-tabs {
          display: flex;
          flex-wrap: nowrap;
          gap: 4px;
          width: 100%;
          margin: 8px 0;
        }

        .meera-style-tabs button {
          flex: 1 1 0;
          min-width: 0;
          padding: 5px 4px;
          font-size: 11px;
          line-height: 1.2;
          white-space: nowrap;
        }

        .meera-style-options {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }

        .meera-style-options button {
          padding: 6px 9px;
          border: 1px solid #222;
          border-radius: 5px;
          background: #fff;
          color: #222;
          font-size: 12px;
          cursor: pointer;
        }

        .meera-style-options button:hover {
          background: #f5f1e8;
        }

        .meera-style-options button:disabled,
        .meera-style-custom button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .meera-style-custom {
          display: flex;
          gap: 6px;
          margin-top: 10px;
        }

        .meera-style-custom input {
          flex: 1;
          min-width: 0;
          padding: 7px 9px;
          border: 1px solid #ccc;
          border-radius: 5px;
          font-size: 12px;
        }

        .meera-style-custom button {
          padding: 7px 10px;
          border: 1px solid #222;
          border-radius: 5px;
          background: #222;
          color: #fff;
          font-size: 12px;
          cursor: pointer;
        }

        .meera-style-loading {
          margin-top: 8px;
          font-size: 12px;
          color: #666;
        }

        #meera-widget-input-area {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 68px;
          display: flex;
          gap: 8px;
          padding: 10px;
          background: #fff;
          border-top: 1px solid #ddd;
        }

        #meera-widget-input {
          flex: 1;
          min-width: 0;
          border: 1px solid #ccc;
          border-radius: 22px;
          padding: 0 14px;
          font-size: 14px;
          outline: none;
        }

        #meera-widget-send {
          width: 70px;
          border: none;
          border-radius: 22px;
          background: #222;
          color: #fff;
          cursor: pointer;
        }

        #meera-widget-send:disabled {
          opacity: 0.5;
          cursor: default;
        }

        .meera-loading {
          color: #777;
          font-style: italic;
        }

        #meera-widget-fit {
          border: 1px solid #ddd;
          border-radius: 6px;
          background: #fff;
          color: #222;
          padding: 5px 8px;
          font-size: 12px;
          cursor: pointer;
        }

        .meera-fit-card {
          margin: 8px 0 12px;
          padding: 12px;
          background: #fbf8f2;
          border: 1px solid #e2ddd2;
          border-radius: 9px;
          color: #222;
        }

        .meera-fit-card h4 { margin: 0 0 6px; font-size: 15px; }
        .meera-fit-card p { margin: 0 0 9px; font-size: 12px; line-height: 1.4; }
        .meera-fit-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
        .meera-fit-field { display: flex; flex-direction: column; gap: 4px; font-size: 11px; }
        .meera-fit-field input, .meera-fit-field select {
          box-sizing: border-box; width: 100%; min-width: 0; padding: 8px;
          border: 1px solid #ccc; border-radius: 5px; background: #fff; font-size: 13px;
        }
        .meera-fit-submit {
          margin-top: 10px; padding: 9px 12px; border: 0; border-radius: 5px;
          background: #222; color: #fff; cursor: pointer; width: 100%;
        }
        .meera-fit-result { margin-top: 10px; padding: 10px; background: #fff; border-radius: 6px; font-size: 12px; line-height: 1.5; }
        .meera-fit-result strong { font-size: 17px; }
        .meera-fit-submit:disabled { opacity: .6; cursor: wait; }

        @media (max-width: 600px) {
          #meera-widget { right: 10px; bottom: 10px; }
          #meera-widget-panel {
            position: fixed;
            width: 100vw;
            max-width: 100vw;
            height: 70dvh;
            max-height: 70dvh;
            top: auto;
            bottom: 0;
            right: 0;
            border-radius: 16px 16px 0 0;
          }
          #meera-widget-panel.meera-maximized {
            height: 100dvh;
            max-height: 100dvh;
            border-radius: 0;
          }
          #meera-widget-header { padding: 10px 12px; }
          #meera-widget-messages {
            height: calc(100% - 112px);
            padding: 10px 9px 8px;
            box-sizing: border-box;
          }
          .meera-message { font-size: 13px; margin-bottom: 9px; }
          .meera-user span, .meera-assistant span { padding: 8px 10px; max-width: 92%; }
          .meera-product img { max-height: 240px; object-fit: contain; }
          .meera-product-body { padding: 8px; }
          .meera-style-box { margin-top: 8px; padding: 8px; }
          .meera-style-title { font-size: 13px; margin-bottom: 6px; }
          .meera-style-tabs { gap: 4px; }
          .meera-style-tabs button { font-size: 10px; padding: 7px 2px; }
          .meera-style-options { gap: 5px; }
          .meera-style-options button { font-size: 11px; padding: 7px 8px; min-height: 34px; }
          #meera-widget-input-area { height: 58px; padding: 7px; gap: 6px; box-sizing: border-box; }
          #meera-widget-input { font-size: 16px; padding: 0 12px; }
          #meera-widget-send { width: 60px; min-width: 60px; }
        }
      </style>

      <button id="meera-widget-button" aria-label="Ask Meera">
        <img
            src="${window.MEERA_LOGO_URL}"
            alt="Meera"
            class="meera-button-icon"
        />
        <span class="meera-button-label">Ask Meera</span>
      </button>

      <div id="meera-widget-panel">
        <div id="meera-widget-header">
          <div class="meera-header-left">
            <img
              src="${window.MEERA_LOGO_URL}"
              alt="Meera"
              class="meera-header-icon"
            />
            <strong>Meera</strong>
          </div>

        <div>

          <button
              id="meera-widget-fit"
              type="button"
              aria-label="Find my size"
              title="Find my size"
            >Fit</button>
          <button
              id="meera-widget-room"
              type="button"
              aria-label="Shop Together"
              title="Shop Together"
            >👥</button>
            <button
              id="meera-widget-maximize"
              aria-label="Maximize Meera"
              title="Maximize"
            >⛶</button>

            <button
              id="meera-widget-close"
              aria-label="Close"
            >×</button>
          </div>
        </div>

        <div id="meera-widget-messages"></div>

        <div id="meera-widget-input-area">
          <input
            id="meera-widget-input"
            type="text"
            placeholder="Ask Meera..."
            autocomplete="off"
          />
          <button id="meera-widget-send">Send</button>
        </div>
      </div>
    `;

    const headerIcons = document.querySelector(".header__utils .header__icons");

    if (headerIcons) {
      const cartIcon = headerIcons.querySelector(".header__icon--cart");
      if (cartIcon) {
        headerIcons.insertBefore(root, cartIcon);
      } else {
        headerIcons.appendChild(root);
      }
    } else {
      document.body.appendChild(root);
    }

    const button = document.getElementById("meera-widget-button");
    const panel = document.getElementById("meera-widget-panel");
    const close = document.getElementById("meera-widget-close");
    const maximize = document.getElementById("meera-widget-maximize");
    const roomButton = document.getElementById("meera-widget-room");
    const fitButton = document.getElementById("meera-widget-fit");
    const input = document.getElementById("meera-widget-input");
    const send = document.getElementById("meera-widget-send");
    const messages = document.getElementById("meera-widget-messages");
    let CHAT_HISTORY_KEY = "meera_chat_history_" + getSessionId();
    const TRYON_DB_NAME = "meera_tryon_history_v1";

    if (fitButton) {
      fitButton.addEventListener("click", renderFitForm);
    }
    let restoringChatHistory = false;
    let clearingForLogout = false;

    function openTryOnDb() {
      return new Promise(function (resolve, reject) {
        if (!window.indexedDB) {
          reject(new Error("IndexedDB is unavailable"));
          return;
        }
        const request = window.indexedDB.open(TRYON_DB_NAME, 1);
        request.onupgradeneeded = function () {
          const db = request.result;
          if (!db.objectStoreNames.contains("images")) {
            db.createObjectStore("images", { keyPath: "key" });
          }
        };
        request.onsuccess = function () { resolve(request.result); };
        request.onerror = function () { reject(request.error || new Error("Could not open Try On history")); };
      });
    }

    async function saveTryOnImage(key, dataUrl) {
      if (!key || !dataUrl || !dataUrl.startsWith("data:image/")) return;
      let db;
      try {
        db = await openTryOnDb();
        await new Promise(function (resolve, reject) {
          const tx = db.transaction("images", "readwrite");
          tx.objectStore("images").put({ key: key, dataUrl: dataUrl, savedAt: Date.now() });
          tx.oncomplete = resolve;
          tx.onerror = function () { reject(tx.error || new Error("Could not save Try On image")); };
          tx.onabort = function () { reject(tx.error || new Error("Try On image save was cancelled")); };
        });
      } catch (error) {
        console.warn("Meera Try On image could not be saved for page navigation:", error);
      } finally {
        if (db) db.close();
      }
    }

    async function loadTryOnImage(key) {
      let db;
      try {
        db = await openTryOnDb();
        return await new Promise(function (resolve, reject) {
          const tx = db.transaction("images", "readonly");
          const request = tx.objectStore("images").get(key);
          request.onsuccess = function () { resolve(request.result ? request.result.dataUrl : null); };
          request.onerror = function () { reject(request.error || new Error("Could not load Try On image")); };
        });
      } catch (error) {
        console.warn("Meera Try On image could not be restored:", error);
        return null;
      } finally {
        if (db) db.close();
      }
    }

    function saveChatHistory() {
      if (restoringChatHistory || clearingForLogout || !messages) return;

      try {
        const history = Array.from(messages.children).map(function (node) {
          if (node.classList.contains("meera-tryon-result")) {
            const noteNode = node.querySelector(":scope > div:not(.meera-style-box)");
            const images = Array.from(node.querySelectorAll("img")).map(function (img) {
              const dataUrl = img.src && img.src.startsWith("data:image/") ? img.src : "";
              if (!dataUrl) return null;
              if (!img.dataset.meeraPersistKey) {
                img.dataset.meeraPersistKey = getSessionId() + "-tryon-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
              }
              if (img.dataset.meeraPersisted !== "1") {
                saveTryOnImage(img.dataset.meeraPersistKey, dataUrl);
                img.dataset.meeraPersisted = "1";
              }
              return { key: img.dataset.meeraPersistKey, alt: img.alt || "Meera Try On preview" };
            }).filter(Boolean);
            return { kind: "tryon", note: noteNode ? noteNode.textContent : "", images: images };
          }
          if (node.classList.contains("meera-message")) {
            if (node.querySelector(".meera-loading") || node.textContent.trim() === "Meera is thinking...") {
              return null;
            }
            return {
              kind: "message",
              type: node.classList.contains("meera-user") ? "user" : "assistant",
              text: node.textContent || ""
            };
          }
          if (node.classList.contains("meera-products") && node.dataset.meeraProductsJson) {
            try {
              return { kind: "products", products: JSON.parse(node.dataset.meeraProductsJson) };
            } catch (error) {
              return null;
            }
          }
          return null;
        }).filter(Boolean);

        // Try On results are usually nested inside product cards, so save them separately
        // from the product recommendation data and restore them after page navigation.
        Array.from(messages.querySelectorAll(".meera-tryon-result")).forEach(function (node) {
          if (node.parentElement === messages) return; // already captured above
          const noteNode = node.querySelector(":scope > div:not(.meera-style-box)");
          const images = Array.from(node.querySelectorAll("img")).map(function (img) {
            const dataUrl = img.src && img.src.startsWith("data:image/") ? img.src : "";
            if (!dataUrl) return null;
            if (!img.dataset.meeraPersistKey) {
              img.dataset.meeraPersistKey = getSessionId() + "-tryon-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
            }
            if (img.dataset.meeraPersisted !== "1") {
              saveTryOnImage(img.dataset.meeraPersistKey, dataUrl);
              img.dataset.meeraPersisted = "1";
            }
            return { key: img.dataset.meeraPersistKey, alt: img.alt || "Meera Try On preview" };
          }).filter(Boolean);
          if (images.length) history.push({ kind: "tryon", note: noteNode ? noteNode.textContent : "", images: images });
        });

        localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(history.slice(-80)));
      } catch (error) {
        console.warn("Meera chat history could not be saved:", error);
      }
    }

    function restoreChatHistory() {
      let history = [];
      try {
        history = JSON.parse(localStorage.getItem(CHAT_HISTORY_KEY) || "[]");
      } catch (error) {
        history = [];
      }
      if (!Array.isArray(history) || history.length === 0) return false;

      restoringChatHistory = true;
      history.forEach(function (item) {
        if (!item) return;
        if (item.kind === "products" && Array.isArray(item.products)) {
          addProducts(item.products);
          return;
        }
        if (item.kind === "tryon" && Array.isArray(item.images)) {
          const result = document.createElement("div");
          result.className = "meera-tryon-result meera-restored-tryon-result";
          result.style.marginTop = "10px";
          if (item.note) {
            const note = document.createElement("div");
            note.textContent = item.note;
            note.style.marginBottom = "8px";
            result.appendChild(note);
          }
          item.images.forEach(function (savedImage) {
            if (!savedImage || !savedImage.key) return;
            const image = document.createElement("img");
            image.alt = savedImage.alt || "Meera Try On preview";
            image.style.cssText = "width:100%;display:block;border-radius:8px;margin-top:8px;";
            image.dataset.meeraPersistKey = savedImage.key;
            image.src = "";
            result.appendChild(image);
            loadTryOnImage(savedImage.key).then(function (dataUrl) {
              if (dataUrl) image.src = dataUrl;
              else image.alt = "This Try On image could not be restored on this page.";
            });
          });
          messages.appendChild(result);
          return;
        }
        if (typeof item.text !== "string") return;
        const message = document.createElement("div");
        message.className = "meera-message " + (item.type === "user" ? "meera-user" : "meera-assistant");
        const span = document.createElement("span");
        span.textContent = item.text;
        message.appendChild(span);
        messages.appendChild(message);
      });
      restoringChatHistory = false;
      messages.scrollTop = messages.scrollHeight;
      return messages.children.length > 0;
    }

    // Save history only at known UI update points. Avoid observing every nested
    // DOM mutation, which can repeatedly serialize large Try On images.
    window.addEventListener("pagehide", saveChatHistory);

    function renderFitForm() {
      const existing = document.getElementById("meera-fit-card");
      if (existing) {
        existing.scrollIntoView({ block: "nearest" });
        return;
      }

      const message = document.createElement("div");
      message.className = "meera-message meera-assistant";
      message.innerHTML = `
        <div class="meera-fit-card" id="meera-fit-card">
          <h4>Find your kurta size</h4>
          <p>Men's kurta beta. Add your usual size or body measurements for a more useful estimate. Measurements are in centimetres. Only enter details you are comfortable submitting for a size estimate.</p>
          <form id="meera-fit-form">
            <div class="meera-fit-grid">
              <label class="meera-fit-field">Usual kurta size
                <select name="usual_size">
                  <option value="">Not sure</option><option>S</option><option>M</option><option>L</option><option>XL</option><option>XXL</option>
                </select>
              </label>
              <label class="meera-fit-field">Fit preference
                <select name="preferred_fit"><option value="regular">Regular</option><option value="close">Close fit</option><option value="relaxed">Relaxed</option></select>
              </label>
              <label class="meera-fit-field">Height (cm)
                <input name="height_cm" type="number" min="100" max="230" placeholder="Optional">
              </label>
              <label class="meera-fit-field">Weight (kg)
                <input name="weight_kg" type="number" min="25" max="300" placeholder="Optional">
              </label>
              <label class="meera-fit-field">Chest (cm)
                <input name="chest" type="number" min="50" max="180" step="0.5" placeholder="Optional">
              </label>
              <label class="meera-fit-field">Shoulder (cm)
                <input name="shoulder" type="number" min="25" max="75" step="0.5" placeholder="Optional">
              </label>
              <label class="meera-fit-field">Waist (cm)
                <input name="waist" type="number" min="45" max="180" step="0.5" placeholder="Optional">
              </label>
              <label class="meera-fit-field">Hip (cm)
                <input name="hip" type="number" min="50" max="180" step="0.5" placeholder="Optional">
              </label>
            </div>
            <button class="meera-fit-submit" type="submit">Recommend my size</button>
            <div class="meera-fit-result" id="meera-fit-result" hidden></div>
          </form>
        </div>`;
      messages.appendChild(message);
      messages.scrollTop = messages.scrollHeight;

      const form = message.querySelector("#meera-fit-form");
      const submit = message.querySelector(".meera-fit-submit");
      const result = message.querySelector("#meera-fit-result");
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        if (submit.disabled) return;

        const formData = new FormData(form);
        const measurements = {};
        ["chest", "shoulder", "waist", "hip"].forEach(function (key) {
          const value = String(formData.get(key) || "").trim();
          if (value) measurements[key] = Number(value);
        });
        const usualSize = String(formData.get("usual_size") || "").trim();
        const height = String(formData.get("height_cm") || "").trim();
        const weight = String(formData.get("weight_kg") || "").trim();
        const payload = {
          category: "mens_kurta",
          usual_size: usualSize || null,
          usual_size_category: "mens_kurta",
          preferred_fit: String(formData.get("preferred_fit") || "regular"),
          height_cm: height ? Number(height) : null,
          weight_kg: weight ? Number(weight) : null,
          body_measurements_cm: Object.keys(measurements).length ? measurements : null
        };

        submit.disabled = true;
        submit.textContent = "Checking size…";
        result.hidden = false;
        result.textContent = "Checking the size chart…";

        try {
          const response = await fetch(MEERA_FIT_API, {
            method: "POST",
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          });
          const data = await meeraReadResponse(response);
          if (!response.ok || !data || data.ok === false) {
            throw new Error((data && (data.detail || data.error)) || "The size service could not complete the request.");
          }
          const explanations = Array.isArray(data.explanation_points) ? data.explanation_points : [];
          const alternatives = Array.isArray(data.alternatives) ? data.alternatives : [];
          result.innerHTML =
            "<strong>" + escapeHtml(data.recommended_size || "No size recommendation") + "</strong>" +
            "<div>Confidence: " + escapeHtml(data.confidence || "not available") + "</div>" +
            (explanations.length ? "<p>" + explanations.map(escapeHtml).join("<br>") + "</p>" : "") +
            (alternatives.length ? "<div>Alternative: " + alternatives.map(escapeHtml).join(", ") + "</div>" : "") +
            "<p>Use this as guidance, not a guaranteed fit. If the recommendation seems unexpected, check your measurements and the product size chart.</p>";
        } catch (error) {
          result.textContent = "Fit recommendations are temporarily unavailable. You can continue shopping with Meera.";
          console.error("Meera Fit Intelligence test request failed:", error);
        } finally {
          submit.disabled = false;
          submit.textContent = "Recommend my size";
          messages.scrollTop = messages.scrollHeight;
        }
      });
      messages.scrollTop = messages.scrollHeight;
    }

    function addMessage(text, type) {
      const message = document.createElement("div");

      message.className =
        "meera-message " +
        (type === "user" ? "meera-user" : "meera-assistant");

      message.innerHTML =
        "<span>" +
        escapeHtml(text).replace(/\n/g, "<br>") +
        "</span>";

      messages.appendChild(message);
      messages.scrollTop = messages.scrollHeight;
      saveChatHistory();

      return message;
    }

    function addProducts(products) {
      if (!Array.isArray(products) || products.length === 0) {
        return;
      }

      const wrapper = document.createElement("div");
      wrapper.className = "meera-products";
      try {
        wrapper.dataset.meeraProductsJson = JSON.stringify(products);
      } catch (error) {
        wrapper.dataset.meeraProductsJson = "";
      }

      products.forEach(function (product) {
        if (!product) {
          return;
        }

        const name =
          product["Product name"] ||
          product["Title"] ||
          "Product";

        const price =
          product["Price"] ??
          product["Variant Price"] ??
          product["price"];

        const image =
          product["Image"] ||
          product["Image URL"] ||
          product["image"];

        const url =
          product["URL"] ||
          product["url"];

        const handle =
          product["Handle"] ||
          product["handle"] ||
          "";
        const productCategory = cleanCategory(
          product["Product Type"] || product["Category"] || product["Type"] || ""
        );

        function cleanCategory(value) {
          return Array.isArray(value) ? value.join(" ") : String(value || "").trim();
        }

        const cleanValue = function (value) {
          if (Array.isArray(value)) {
            return value.filter(Boolean).join(" ");
          }
          return value == null ? "" : String(value).trim();
        };

        const colour = cleanValue(
          product["Colour"] ||
          product["Colour (product.metafields.kosala.colour)"]
        );
        const fabric = cleanValue(product["Fabric"]);
        const technique = cleanValue(product["Technique"]);
        const occasion = cleanValue(
          product["Best For"] ||
          product["Primary Occasion"] ||
          product["Occasion"]
        );
        const usp = cleanValue(product["Product USP"]);
        const luxuryPoint = cleanValue(product["Luxury Selling Point"]);
        const story = cleanValue(
          product["Product Story"] ||
          product["Description"]
        );
        const stylePersona = cleanValue(product["Style Persona"]);
        const mood = cleanValue(product["Mood"]);
        const recommendationReason = cleanValue(
          product["__meera_recommendation_reason"] ||
          product["Recommendation Reason"] ||
          product["Recommendation Reasons"]
        );

        const detailItem = function (label, value) {
          if (!value) return "";
          return `
            <div class="meera-detail-item">
              <span class="meera-detail-label">${escapeHtml(label)}</span>
              <div class="meera-detail-value">${escapeHtml(value)}</div>
            </div>
          `;
        };

        const detailSection = function (title, value, extraClass) {
          if (!value) return "";
          return `
            <div class="meera-detail-section ${extraClass || ""}">
              <div class="meera-detail-title">${escapeHtml(title)}</div>
              <div class="meera-detail-text">${escapeHtml(value)}</div>
            </div>
          `;
        };

        const card = document.createElement("div");
        card.className = "meera-product";

        let html = "";

        if (image) {
          html += `
            <img
              src="${escapeHtml(image)}"
              alt="${escapeHtml(name)}"
              loading="lazy"
            />
          `;
        }

        html += `
          <div class="meera-product-body">
            <div class="meera-product-name">
              ${escapeHtml(name)}
            </div>

            <div class="meera-product-price">
              ${escapeHtml(formatPrice(price))}
            </div>
        `;

        if (url) {
          html += `
            <a
              class="meera-product-link"
              href="${escapeHtml(url)}"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Product
            </a>
          `;
          // Try It On is for garments only. Fabric sold by the metre
          // (yardage) is not something a customer can "wear" in a photo.
          const isFabric = /yardage|fabric/i.test(productCategory + " " + name);
          if (!isFabric) {
            html += `
            <button
              type="button"
              class="meera-tryon-button"
              data-product-handle="${escapeHtml(handle)}"
              data-product-category="${escapeHtml(productCategory)}"
            >
              ✨ Try It On
            </button>
            `;
          }
        }

        html += `
            <div class="meera-product-details">
              <div class="meera-detail-grid">
                ${detailItem("Colour", colour)}
                ${detailItem("Fabric", fabric)}
                ${detailItem("Technique", technique)}
                ${detailItem("Perfect For", occasion)}
                ${detailItem("Style Persona", stylePersona)}
                ${detailItem("Mood", mood)}
              </div>

              ${detailSection("Why this is special", usp)}
              ${detailSection("The craft", technique ? technique + (luxuryPoint ? " · " + luxuryPoint : "") : luxuryPoint)}
              ${detailSection("The story", story)}
              ${detailSection("Perfect for this occasion", occasion)}

              ${recommendationReason ? `
                <div class="meera-detail-section">
                  <div class="meera-detail-title">Why Meera picked this</div>
                  <div class="meera-detail-text meera-reason-box">${escapeHtml(recommendationReason)}</div>
                </div>
              ` : ""}
            </div>
          </div>
        `;

        card.innerHTML = html;
        wrapper.appendChild(card);
      });

      messages.appendChild(wrapper);
      messages.scrollTop = messages.scrollHeight;
      saveChatHistory();
    
      wrapper.querySelectorAll(".meera-tryon-button").forEach(function (tryButton) {
        tryButton.addEventListener("click", function () {
          const handle = tryButton.getAttribute("data-product-handle");

          if (!handle) {
            addMessage("This product cannot be tried on right now.", "assistant");
            return;
          }

          let input = tryButton.parentElement.querySelector(".meera-tryon-input");

          if (!input) {
            input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*";
            input.className = "meera-tryon-input";
            input.style.display = "none";
            input.setAttribute("data-product-handle", handle);

            tryButton.parentElement.appendChild(input);
          }

          input.addEventListener("change", async function () {
            const file = input.files && input.files[0];

            if (!file) {
              return;
            }

            if (!file.type.startsWith("image/")) {
              addMessage("Please choose an image file.", "assistant");
              input.value = "";
              return;
            }

            if (file.size > 10 * 1024 * 1024) {
              addMessage("Please choose an image smaller than 10 MB.", "assistant");
              input.value = "";
              return;
            }

            let tryOnStatusMessage = null;
            try {
              tryOnStatusMessage = addMessage("Meera is creating your Try On...", "assistant");

              const formData = new FormData();
              formData.append("session_id", getSessionId());
              formData.append("photo", file);
              formData.append("product_handle", handle);

              const response = await fetch(MEERA_API + "/tryon", {
                method: "POST",
                body: formData
              });

              const responseText = await response.text();
              let data;
              try {
                data = JSON.parse(responseText);
              } catch (parseError) {
                console.error("Meera Try On returned non-JSON response", {
                  status: response.status,
                  body: responseText.slice(0, 500)
                });
                throw new Error("The Try On service returned an unexpected response (HTTP " + response.status + ").");
              }

              if (data.error === "Shopify customer login required") {
                addMessage("Please log in to your Kosala account to use Try It On.", "assistant");
                return;
              }

              if (!response.ok) {
                console.error("Meera Try On HTTP error", response.status, data);
                throw new Error(data.message || data.error || "Try On request failed with HTTP " + response.status + ".");
              }

              if (!data.ok || !data.image_base64) {
                console.warn("Meera Try On returned no image", { status: response.status, data: data });
                addMessage(
                  data.message || data.error || "I couldn't create the Try On preview right now. Please try again.",
                  "assistant"
                );
                return;
              }

              // A previous guest attempt may have left a login warning in the chat.
              // Once a Try On succeeds, remove that stale warning and persist the clean history.
              Array.from(messages.querySelectorAll(".meera-assistant")).forEach(function (messageNode) {
                const textNode = messageNode.querySelector("span");
                if (textNode && textNode.textContent.trim() === "Please log in to your Kosala account to use Try It On.") {
                  messageNode.remove();
                }
              });
              saveChatHistory();

              // Follow-up styling must start from the latest generated preview, not the original upload.
              let currentTryOnImageBase64 = data.image_base64;

              const result = document.createElement("div");
              result.className = "meera-tryon-result";
              result.style.marginTop = "10px";

              if (data.message) {
                const note = document.createElement("div");
                note.textContent = data.message;
                note.style.marginBottom = "8px";
                result.appendChild(note);
              }

              const image = document.createElement("img");
              image.alt = data.product_name
                ? "Try-on preview for " + data.product_name
                : "Meera Try On preview";
              image.src = "data:image/png;base64," + data.image_base64;
              image.style.width = "100%";
              image.style.display = "block";
              image.style.borderRadius = "8px";

              result.appendChild(image);

              const styleBox = document.createElement("div");
              styleBox.className = "meera-style-box";

              const productCard = tryButton.closest(".meera-product");
              const productTitle = productCard && productCard.querySelector(".meera-product-name")
                ? productCard.querySelector(".meera-product-name").textContent
                : "";
              const categoryText = [
                tryButton.getAttribute("data-product-category") || "",
                productTitle,
                handle || ""
              ].join(" ").toLowerCase();

              let styleOptions = [];

              if (categoryText.includes("saree")) {
                styleOptions = [
                  {
                    label: "Matching Blouse Colour",
                    instruction: "Style the saree with a blouse matching the blouse colour already shown with the saree or in the original product styling. Do not introduce a contrast colour unless explicitly requested. Preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "Boat Neck Blouse",
                    instruction: "Style the saree with a boat-neck blouse, retaining the existing blouse colour. Preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "High Neck Blouse",
                    instruction: "Style the saree with a high-neck blouse, retaining the existing blouse colour. Change the neckline only; preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "Full Sleeves",
                    instruction: "Style the saree with a full-sleeve blouse, retaining the existing blouse colour. Preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "3/4 Sleeves",
                    instruction: "Style the saree with a three-quarter-sleeve blouse, retaining the existing blouse colour. Preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "Elbow Sleeves",
                    instruction: "Style the saree with an elbow-sleeve blouse, retaining the existing blouse colour. Preserve the saree's original colour, weave, border and design."
                  },
                  {
                    label: "Traditional Blouse",
                    instruction: "Style the saree with a traditional Indian blouse featuring refined detailing, retaining the existing blouse colour. Preserve the saree's original design."
                  },
                  {
                    label: "Front Pallu",
                    instruction: "Style the saree with an elegant front pallu drape. Preserve its original colour, weave, border and design."
                  },
                  {
                    label: "Open Pallu",
                    instruction: "Style the saree with an elegant open pallu drape. Preserve its original colour, weave, border and design."
                  },
                  {
                    label: "Traditional Drape",
                    instruction: "Style the saree in a graceful traditional Indian drape. Preserve its original colour, weave, border and design."
                  },
                  {
                    label: "Jewellery",
                    instruction: "Recommend and visualize jewellery that complements the existing saree and blouse colours. Preserve the outfit's original design."
                  },
                  {
                    label: "Complete the Look",
                    instruction: "Complete the saree look with suitable jewellery, footwear and accessories. Preserve the original saree and blouse colours, weave, border and design."
                  }
                ];
              } else if (
                categoryText.includes("women") ||
                categoryText.includes("ladies") ||
                categoryText.includes("female")
              ) {
                styleOptions = [
                  { label: "Full Sleeves", instruction: "Style the women's kurta with full sleeves while preserving its original colour and design." },
                  { label: "3/4 Sleeves", instruction: "Style the women's kurta with three-quarter sleeves while preserving its original colour and design." },
                  { label: "Add Dupatta", instruction: "Complete the women's kurta look with a suitable dupatta, preserving the original garment's colour and design." },
                  { label: "Jewellery", instruction: "Style the women's kurta with elegant suitable jewellery, preserving the original garment's design." },
                  { label: "Complete the Look", instruction: "Complete the women's kurta look with suitable accessories, footwear and jewellery, preserving the original garment's design." }
                ];
              } else if (
                categoryText.includes("men") ||
                categoryText.includes("male") ||
                categoryText.includes("kurta") ||
                categoryText.includes("nehru jacket")
              ) {
                styleOptions = [
                  { label: "Add Nehru Jacket", instruction: "Style the existing men's outfit with a suitable Nehru jacket. Choose a complementary colour while preserving the original garment's design." },
                  { label: "Festive Layering", instruction: "Create a refined festive layered look with a suitable jacket. Preserve the original garment's colour and design." },
                  { label: "Add Stole", instruction: "Complete the men's kurta look with a suitable stole, preserving the original garment's colour and design." },
                  { label: "Traditional Footwear", instruction: "Complete the men's outfit with suitable traditional footwear, preserving the original garment's design." },
                  { label: "Complete the Look", instruction: "Create the best coordinated complete festive look for this men's kurta. Choose the most suitable complementary Nehru jacket or layer if it improves the outfit, a matching or tasteful contrasting stole only if appropriate, traditional footwear such as mojaris or juttis, and restrained accessories such as a pocket square or watch where suitable. Use your styling judgement; do not add every accessory automatically. Preserve the original kurta's exact colour, weave, pattern, buttons and design, and keep the kurta as the main garment." }
                ];
              } else {
                styleOptions = [
                  { label: "Jewellery", instruction: "Style the look with suitable elegant jewellery while preserving the outfit's original design." },
                  { label: "Complete the Look", instruction: "Complete the look with suitable accessories and styling while preserving the outfit's original design." }
                ];
              }

              let styleGroups;
              if (categoryText.includes("saree")) {
                styleGroups = [
                  { label: "Blouse", options: styleOptions.filter(function (o) { return ["Matching Blouse Colour", "Boat Neck Blouse", "High Neck Blouse", "Full Sleeves", "3/4 Sleeves", "Elbow Sleeves", "Traditional Blouse"].includes(o.label); }) },
                  { label: "Pallu & Drape", options: styleOptions.filter(function (o) { return ["Front Pallu", "Open Pallu", "Traditional Drape"].includes(o.label); }) },
                  { label: "Style the Look", options: styleOptions.filter(function (o) { return ["Jewellery", "Complete the Look"].includes(o.label); }) }
                ];
              } else if (
                categoryText.includes("women") ||
                categoryText.includes("ladies") ||
                categoryText.includes("female")
              ) {
                styleGroups = [
                  { label: "Sleeves", options: styleOptions.filter(function (o) { return ["Full Sleeves", "3/4 Sleeves"].includes(o.label); }) },
                  { label: "Dupatta", options: styleOptions.filter(function (o) { return o.label === "Add Dupatta"; }) },
                  { label: "Style the Look", options: styleOptions.filter(function (o) { return ["Jewellery", "Complete the Look"].includes(o.label); }) }
                ];
              } else if (
                categoryText.includes("men") ||
                categoryText.includes("male") ||
                categoryText.includes("kurta") ||
                categoryText.includes("nehru jacket")
              ) {
                styleGroups = [
                  { label: "Layering", options: styleOptions.filter(function (o) { return ["Add Nehru Jacket", "Festive Layering", "Add Stole"].includes(o.label); }) },
                  { label: "Accessories", options: styleOptions.filter(function (o) { return o.label === "Traditional Footwear"; }) },
                  { label: "Style the Look", options: styleOptions.filter(function (o) { return o.label === "Complete the Look"; }) }
                ];
              } else {
                styleGroups = [{ label: "Style the Look", options: styleOptions }];
              }
              styleGroups = styleGroups.filter(function (group) { return group.options.length > 0; });

              styleBox.innerHTML = `
                <div class="meera-style-title">✨ Style this look</div>
                ${styleGroups.length > 1 ? `
                  <div class="meera-style-tabs">
                    ${styleGroups.map(function (group, index) { return `
                      <button type="button" data-style-group="${index}" aria-pressed="false" style="border:1px solid #cdbb91;border-radius:18px;background:#fff;cursor:pointer;">
                        ${escapeHtml(group.label)}
                      </button>
                    `; }).join("")}
                  </div>
                ` : ""}
                ${styleGroups.map(function (group, index) { return `
                  <div class="meera-style-options" data-style-panel="${index}" style="display:none;gap:6px;flex-wrap:wrap;margin:8px 0;">
                    ${group.options.map(function (option) { return `
                      <button type="button" data-style="${escapeHtml(option.instruction)}">${escapeHtml(option.label)}</button>
                    `; }).join("")}
                  </div>
                `; }).join("")}
                <div class="meera-style-custom" style="display:none;">
                  <input type="text" placeholder="Describe another style..." />
                  <button type="button">Style It</button>
                </div>
              `;

              // Make the first style category immediately usable; otherwise all option
              // panels are hidden until a tab is clicked (and generic categories have no tab).
              const initialTab = styleBox.querySelector("[data-style-group]");
              if (initialTab) {
                initialTab.setAttribute("aria-pressed", "true");
                initialTab.style.background = "#dfcca0";
              }
              const initialPanel = styleBox.querySelector('[data-style-panel="0"]');
              if (initialPanel) {
                initialPanel.style.display = "none";
              }

              styleBox.querySelectorAll("[data-style-group]").forEach(function (tab) {
                tab.addEventListener("click", function () {
                  const selected = tab.getAttribute("data-style-group");
                  styleBox.querySelectorAll("[data-style-group]").forEach(function (otherTab) {
                    const active = otherTab === tab;
                    otherTab.setAttribute("aria-pressed", active ? "true" : "false");
                    otherTab.style.background = active ? "#dfcca0" : "#fff";
                  });
                  styleBox.querySelectorAll("[data-style-panel]").forEach(function (panel) {
                    panel.style.display = panel.getAttribute("data-style-panel") === selected ? "flex" : "none";
                  });
                  const customStyle = styleBox.querySelector(".meera-style-custom");
                  if (customStyle) customStyle.style.display = "flex";
                });
              });

              result.appendChild(styleBox);

              styleBox.querySelectorAll("[data-style]").forEach(function (styleButton) {
                styleButton.addEventListener("click", async function () {
                  await generateStyledTryon(styleButton.getAttribute("data-style"));
                });
              });

              const customInput = styleBox.querySelector("input");
              const customButton = styleBox.querySelector(".meera-style-custom button");

              customButton.addEventListener("click", async function () {
                const instruction = customInput.value.trim();

                if (!instruction) {
                  return;
                }

                await generateStyledTryon(instruction);
              });

              async function base64ImageToBlobInChunks(base64, chunkSize) {
                const binaryChunks = [];
                const size = chunkSize || 1024 * 1024;
                for (let offset = 0; offset < base64.length; offset += size) {
                  const chunk = base64.slice(offset, offset + size);
                  const binary = atob(chunk);
                  const bytes = new Uint8Array(binary.length);
                  for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                  }
                  binaryChunks.push(bytes);
                  // Yield between chunks to let Chrome process paint/input events.
                  await new Promise(function (resolve) { window.setTimeout(resolve, 0); });
                }
                return new Blob(binaryChunks, { type: "image/png" });
              }

              let stylingRequestInProgress = false;
              async function generateStyledTryon(instruction) {
                if (stylingRequestInProgress) return;
                stylingRequestInProgress = true;
                styleBox.querySelectorAll("button").forEach(function (button) {
                  button.disabled = true;
                });

                const loading = document.createElement("div");
                loading.className = "meera-style-loading";
                loading.textContent = "Meera is styling your look...";
                styleBox.appendChild(loading);

                try {
                  const formData = new FormData();

                  formData.append("session_id", getSessionId());
                  // Decode the latest generated image in small chunks so a large
                  // Base64 payload does not monopolize the browser's main thread.
                  const latestImageBlob = await base64ImageToBlobInChunks(
                    currentTryOnImageBase64,
                    1024 * 1024
                  );
                  formData.append("photo", latestImageBlob, "meera-latest-tryon.png");
                  formData.append("product_handle", handle);
                  formData.append("notes", instruction);

                  const response = await fetch("/apps/meera/tryon", {
                    method: "POST",
                    body: formData
                  });

                  const responseText = await response.text();

                  let styledData;

                  try {
                    styledData = JSON.parse(responseText);
                  } catch (parseError) {
                    console.error("Styled try-on raw response:", responseText);

                    throw new Error(
                      "Styled try-on server returned HTTP " +
                      response.status +
                      " instead of JSON."
                    );
                  }

                  if (!response.ok) {
                    console.error("Styled try-on server error:", styledData);

                    throw new Error(
                      styledData.message ||
                      styledData.error ||
                      "Styled try-on request failed with HTTP " + response.status
                    );
                  }

                  if (styledData.error === "Shopify customer login required") {
                    loading.textContent = "Your Kosala login could not be verified for styling. Refresh the page while logged in, then try again.";
                    console.warn("Styled Try On authentication was rejected", {
                      status: response.status,
                      session_id: getSessionId(),
                      endpoint: "/apps/meera/tryon"
                    });
                    return;
                  }

                  if (!styledData.ok || !styledData.image_base64) {
                    loading.textContent =
                      styledData.message ||
                      styledData.error ||
                      "I couldn't create that styling variation right now.";
                    return;
                  }

                  loading.remove();

                  const styledImage = document.createElement("img");

                  styledImage.alt = styledData.product_name
                    ? "Styled try-on for " + styledData.product_name
                    : "Styled Meera try-on";

                  styledImage.src =
                    "data:image/png;base64," + styledData.image_base64;

                  // The next style request chains from this newest generated result.
                  currentTryOnImageBase64 = styledData.image_base64;

                  styledImage.style.width = "100%";
                  styledImage.style.display = "block"
                  styledImage.style.borderRadius = "8px";

                  image.src = styledImage.src;
                  image.alt = styledImage.alt;
                  saveChatHistory();

                  messages.scrollTop = messages.scrollHeight;

                } catch (error) {
                  console.error("Styled try-on error:", error);

                  loading.textContent =
                    "Something went wrong while creating the styled look.";

                } finally {
                  stylingRequestInProgress = false;
                  styleBox.querySelectorAll("button").forEach(function (button) {
                    button.disabled = false;
                  });
                }
              }
              input.parentElement.appendChild(result);
              saveChatHistory();

              messages.scrollTop = messages.scrollHeight;

            } catch (error) {
              console.error("Meera Try On request failed:", error);
              addMessage(
                "Meera couldn't complete the Try On request this time. Please try again in a moment.",
                "assistant"
              );
            } finally {
              if (tryOnStatusMessage && tryOnStatusMessage.isConnected) {
                tryOnStatusMessage.remove();
              }
              input.value = "";
            }
          });

          input.click();
      });
      });
      }
      
    async function sendMessage() {
      const message = input.value.trim();

      if (!message || send.disabled) {
        return;
      }

      addMessage(message, "user");

      input.value = "";
      send.disabled = true;
      input.disabled = true;

      const loading = addMessage("Meera is thinking...", "assistant");
      loading.querySelector("span").classList.add("meera-loading");

      try {
        // The backend can be asleep (free/starter hosting) or briefly
        // unreachable. Retry quietly instead of showing an error at once.
        const sendOnce = function () {
          return fetch(MEERA_API + "/chat", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              session_id: getSessionId(),
              message: message
            })
          });
        };

        let response = null;
        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            response = await sendOnce();
            if (response.ok) break;
            if (response.status < 500 && response.status !== 429) break;
          } catch (networkError) {
            response = null;
          }
          if (attempt === 0) {
            const span = loading.querySelector("span");
            if (span) span.textContent = "Meera is stepping back to her loom for a moment...";
          }
          await new Promise(function (r) { setTimeout(r, 2500 * (attempt + 1)); });
        }

        if (!response || !response.ok) {
          throw new Error("API request failed: " + (response ? response.status : "network"));
        }

        const data = await response.json();

        loading.remove();

        if (data.message) {
          addMessage(data.message, "assistant");
        }

        if (Array.isArray(data.products) && data.products.length) {
          meeraTagCart();
        }

        if (Array.isArray(data.products)) {
          const productsWithReason = data.products.map(function (product, index) {
            return Object.assign({}, product, {
              __meera_recommendation_reason:
                index === 0 ? (data.recommendation_reason || "") : ""
            });
          });

          addProducts(productsWithReason);
        }

        if (
          (!data.message || data.message.trim() === "") &&
          (!Array.isArray(data.products) || data.products.length === 0)
        ) {
          addMessage(
            "Tell me a little more, such as the occasion, a colour you love or a budget, and I'll find something lovely.",
            "assistant"
          );
        }
      } catch (error) {
        console.error("Meera widget error:", error);

        loading.remove();

        addMessage(
          "I lost the thread for a moment. Your message is safe: tap send once more, or write to us at support@kosala.com and the team will help right away.",
          "assistant"
        );
      } finally {
        send.disabled = false;
        input.disabled = false;
        input.focus();
      }
    }

    let meeraWarmed = false;
    button.addEventListener("click", function () {
      // Wake the backend while the customer is still reading the greeting.
      if (!meeraWarmed) {
        meeraWarmed = true;
        try { fetch(MEERA_API + "/health").catch(function () {}); } catch (e) {}
      }
      panel.style.display = "block";
      input.focus();
    });

    close.addEventListener("click", function () {
      panel.style.display = "none";
    });

    // On phones the chat is a full-screen sheet. Keep it exactly the size of
    // the VISIBLE viewport so the keyboard never hides the input box.
    const meeraIsMobile = function () {
      return window.matchMedia("(max-width: 600px)").matches;
    };
    const fitPanelToVisibleViewport = function () {
      if (!meeraIsMobile() || panel.style.display === "none") return;
      const vv = window.visualViewport;
      if (!vv) return;
      panel.style.height = Math.floor(vv.height) + "px";
      panel.style.top = Math.floor(vv.offsetTop) + "px";
      panel.style.bottom = "auto";
      messages.scrollTop = messages.scrollHeight;
    };
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", fitPanelToVisibleViewport);
      window.visualViewport.addEventListener("scroll", fitPanelToVisibleViewport);
    }

    // Clear the active conversation immediately when a Shopify logout is initiated.
    // Also clear the visible DOM: the widget can remain mounted in the same tab
    // while Shopify changes the account state.
    function clearMeeraConversationForLogout() {
      try {
        clearingForLogout = true;
        const oldSessionId = sessionStorage.getItem(SESSION_KEY);
        if (oldSessionId) {
          sessionStorage.setItem("meera_logout_pending", oldSessionId);
          localStorage.removeItem("meera_chat_history_" + oldSessionId);
        }
        const legacySessionId = localStorage.getItem(SESSION_KEY);
        if (legacySessionId) localStorage.removeItem("meera_chat_history_" + legacySessionId);

        sessionStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem("meera_room_code");
        localStorage.removeItem("meera_room_name");

        // Create a fresh anonymous session for the still-open tab.
        const freshSessionId = getSessionId();
        CHAT_HISTORY_KEY = "meera_chat_history_" + freshSessionId;
        localStorage.removeItem(CHAT_HISTORY_KEY);

        if (messages) {
          messages.replaceChildren();
          addMessage("Hi, I'm Meera. What are you looking for today?", "assistant");
        }
        saveChatHistory();
      } catch (error) {
        console.warn("Meera could not clear local session during logout:", error);
      } finally {
        clearingForLogout = false;
      }
    }

    function isLogoutTarget(target) {
      if (!target || !target.closest) return false;
      return target.closest(
        'a[href*="logout"], button[name="logout"], input[name="logout"], form[action*="logout"], [data-logout], [aria-label*="log out" i], [aria-label*="logout" i]'
      );
    }

    document.addEventListener("click", function (event) {
      if (isLogoutTarget(event.target)) clearMeeraConversationForLogout();
    }, true);

    document.addEventListener("submit", function (event) {
      const form = event.target;
      if (form && form.matches && form.matches('form[action*="logout"]')) {
        clearMeeraConversationForLogout();
      }
    }, true);

    maximize.addEventListener("click", function () {
      const isMaximized = panel.classList.toggle("meera-maximized");

      if (isMaximized) {
        maximize.textContent = "↙";
        maximize.setAttribute("aria-label", "Restore Meera");
        maximize.setAttribute("title", "Restore");
      } else {
        maximize.textContent = "⛶";
        maximize.setAttribute("aria-label", "Maximize Meera");
        maximize.setAttribute("title", "Maximize");
      }
    });
    roomButton.addEventListener("click", function () {
      let roomPanel = document.getElementById("meera-room-panel");

      if (roomPanel) {
        roomPanel.style.display = "flex";
        return;
      }

      roomPanel = document.createElement("div");
      roomPanel.id = "meera-room-panel";

      roomPanel.innerHTML = `
        <div class="meera-room-box">

          <div class="meera-room-header">
            <strong>👥 Shop Together</strong>

            <button
              type="button"
              id="meera-room-close"
              aria-label="Close Shop Together"
            >×</button>
          </div>

          <div class="meera-room-content">

            <div class="meera-room-section">
              <div class="meera-room-title">
                Shop with family or friends
              </div>

              <div class="meera-room-description">
                Create a shared shopping room and let everyone browse,
                chat and react to products together.
              </div>

              <input
                id="meera-room-name"
                type="text"
                placeholder="Your name"
              />

              <button
                type="button"
                id="meera-room-create"
              >
                Create a Room
              </button>
            </div>

            <div class="meera-room-divider">
              or
            </div>

            <div class="meera-room-section">

              <input
                id="meera-room-code"
                type="text"
                placeholder="Enter room code"
                maxlength="5"
              />

              <button
                type="button"
                id="meera-room-join"
              >
                Join a Room
              </button>

            </div>

          </div>
        </div>
      `;

      panel.appendChild(roomPanel);

      document
        .getElementById("meera-room-close")
        .addEventListener("click", function () {
          roomPanel.style.display = "none";
        });
      document
        .getElementById("meera-room-create")
        .addEventListener("click", async function () {
            const nameInput = document.getElementById("meera-room-name");
            const createButton = document.getElementById("meera-room-create");
            const name = nameInput.value.trim();

            if (!name) {
              nameInput.focus();
              return;
            }
            createButton.disabled = true;
            createButton.textContent = "Creating...";
  
      try {
        const response = await fetch(MEERA_API + "/room/create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            host_name: name
          })
        });

        const data = await response.json();

        if (!response.ok || !data.code) {
          throw new Error(
            data.message ||
            data.error ||
            "Could not create the room."
          );
        }

        console.log("Meera room created:", data);

        localStorage.setItem("meera_room_code", data.code);
        localStorage.setItem("meera_room_name", name);

        openShoppingRoom(data, name);
        

      } catch (error) {
        console.error("Room creation error:", error);

        alert(
          error.message ||
          "Something went wrong while creating the room."
        );

      } finally {
        createButton.disabled = false;
        createButton.textContent = "Create a Room";
      }
    });
        document
        .getElementById("meera-room-join")
        .addEventListener("click", async function () {
          const codeInput =
            document.getElementById("meera-room-code");

          const nameInput =
            document.getElementById("meera-room-name");

          const joinButton =
            document.getElementById("meera-room-join");

          const code = codeInput.value.trim().toUpperCase();
          const name = nameInput.value.trim();

          if (!name) {
            nameInput.focus();
            return;
          }

          if (!code) {
            codeInput.focus();
            return;
          }

          joinButton.disabled = true;
          joinButton.textContent = "Joining...";

          try {
            const response = await fetch(
              MEERA_API + "/room/" + encodeURIComponent(code) + "/join",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  name: name
                })
              }
            );

            const data = await response.json();

            if (!response.ok || data.error) {
              throw new Error(
                data.message ||
                data.error ||
                "Could not join the room."
              );
            }

            console.log("Meera room joined:", data);
            localStorage.setItem("meera_room_code", data.code);
            localStorage.setItem("meera_room_name", name);

            openShoppingRoom(data, name);

          } catch (error) {
            console.error("Room join error:", error);

            alert(
              error.message ||
              "Something went wrong while joining the room."
            );

          } finally {
            joinButton.disabled = false;
            joinButton.textContent = "Join a Room";
          }
        });
    });  
    
    function openShoppingRoom(roomData, currentUserName) {

      const roomPanel =
        document.getElementById("meera-room-panel");

      if (roomPanel) {
        roomPanel.style.display = "none";
      }

      let shoppingRoom =document.getElementById("meera-shopping-room");

      if (shoppingRoom) {
        shoppingRoom.remove();
      }

      shoppingRoom = document.createElement("div");

      shoppingRoom.id = "meera-shopping-room";

      shoppingRoom.innerHTML = `
        <div class="meera-shopping-room-box">

          <div class="meera-shopping-room-header">
            <div class="meera-shopping-room-header-main">
              <strong>👥 Shopping Room</strong>
              <div class="meera-shopping-room-code-row">
                <div class="meera-shopping-room-code" aria-label="Room code">
                  CODE: ${escapeHtml(roomData.code || "Unavailable")}
                </div>
                <button
                  type="button"
                  id="meera-shopping-room-copy-code"
                  class="meera-room-header-action"
                  aria-label="Copy room code"
                >Copy code</button>
              </div>
            </div>

            <div class="meera-shopping-room-header-actions">
              <button
                type="button"
                id="meera-shopping-room-maximize"
                class="meera-room-header-action"
                aria-label="Maximize Shopping Room"
                title="Maximize Shopping Room"
              >⛶ Maximize</button>
              <button
                type="button"
                id="meera-shopping-room-back"
                class="meera-room-header-action"
                aria-label="Back to Meera chat"
                title="Return to private Meera chat"
              >← Meera</button>
              <button
                type="button"
                id="meera-shopping-room-close"
                aria-label="Close Shopping Room"
                title="Close Shopping Room"
              >×</button>
            </div>
          </div>

          <div class="meera-shopping-room-participants">
            <strong>Shopping with</strong>
            <div id="meera-shopping-participants"></div>
          </div>

          <div
            id="meera-shopping-transcript"
            class="meera-shopping-transcript"
          ></div>

         <div class="meera-shopping-room-input">

            <textarea
              id="meera-shopping-message"
              placeholder="Message everyone..."
              rows="2"
            ></textarea>

            <div class="meera-shopping-room-actions">

              <label class="meera-room-meera-toggle" for="meera-shopping-ask-meera">
                <input
                  type="checkbox"
                  id="meera-shopping-ask-meera"
                />
                <span>Ask Meera</span>
              </label>

              <button
                type="button"
                id="meera-shopping-send"
              >
                Send
              </button>

            </div>

          </div>

        </div>
      `;

      panel.appendChild(shoppingRoom);

      const transcript =
        shoppingRoom.querySelector("#meera-shopping-transcript");

      const participants =
        shoppingRoom.querySelector("#meera-shopping-participants");

      const messageInput =
        shoppingRoom.querySelector("#meera-shopping-message");

      const askMeera =
        shoppingRoom.querySelector("#meera-shopping-ask-meera");

      const sendButton =
        shoppingRoom.querySelector("#meera-shopping-send");

      // Keep Try On results across the room's 2-second refresh cycle.
      const roomTryOnResults = Object.create(null);
      const roomTryOnFetches = Object.create(null);
      const roomTryOnInProgress = Object.create(null);
      let latestRoom = roomData;
      let roomFilePickerActive = false;
      let roomStyleRequestActive = false;

      function renderRoom(room) {
        // Do not rebuild the transcript while a native file picker or style request
        // is active: rebuilding detaches the hidden file input and can require
        // repeated Try It On taps on mobile.
        if (roomFilePickerActive || roomStyleRequestActive) {
          latestRoom = room;
          return;
        }
        // Preserve the reader's position across the room's 2-second refresh.
        // Only auto-follow new content when the reader was already near the bottom.
        const previousScrollTop = transcript.scrollTop;
        const wasNearBottom =
          transcript.scrollHeight - transcript.scrollTop - transcript.clientHeight < 80;

        latestRoom = room;
        // Discover shared Try On updates using lightweight metadata, then fetch each image once.
        Object.keys(room.tryon_meta || {}).forEach(function (pid) {
          const meta = room.tryon_meta[pid];
          const current = roomTryOnResults[pid];
          if (current && current.updated_at === meta.updated_at) return;
          if (roomTryOnFetches[pid]) return;
          roomTryOnFetches[pid] = true;
          fetch(MEERA_API + "/room/" + encodeURIComponent(room.code) + "/tryon/" + encodeURIComponent(pid))
            .then(function (response) { return response.json(); })
            .then(function (result) {
              if (result && result.image_base64) {
                roomTryOnResults[pid] = result;
                renderRoom(latestRoom || room);
              }
            })
            .catch(function (error) { console.error("Shared Try On fetch error:", error); })
            .finally(function () { roomTryOnFetches[pid] = false; });
        });
        participants.innerHTML = "";

        (room.participants || []).forEach(function (person) {
          const personTag = document.createElement("span");
          personTag.className = "meera-room-person";
          personTag.textContent = "👤 " + person;
          participants.appendChild(personTag);
        });

        transcript.innerHTML = "";

        (room.transcript || []).forEach(function (item) {

          const message = document.createElement("div");

          message.className =
            "meera-room-message " +
            (item.who === "Meera"
              ? "meera-room-message-meera"
              : item.kind === "system"
              ? "meera-room-message-system"
              : "meera-room-message-user");

          const who = document.createElement("div");
          who.className = "meera-room-message-who";
          who.textContent = item.who || "Guest";

          const text = document.createElement("div");
          text.className = "meera-room-message-text";
          text.textContent = item.text || "";

          message.appendChild(who);
          message.appendChild(text);

          if (item.product) {
            const productBox = document.createElement("div");
            productBox.className = "meera-room-product";

            const productName =
              item.product["Product name"] ||
              item.product["Title"] ||
              item.product["title"] ||
              "Product";

            const productImage =
              item.product["Image"] ||
              item.product["Image URL"] ||
              item.product["image"];

            if (productImage) {
              const image = document.createElement("img");

              image.src = productImage;
              image.alt = productName;
              image.loading = "lazy";

              productBox.appendChild(image);
            }

            const productTitle =
              document.createElement("div");

            productTitle.className = "meera-room-product-name";
            productTitle.textContent = productName;
            productBox.appendChild(productTitle);

            const productMeta = document.createElement("div");
            productMeta.className = "meera-room-product-meta";
            const metaFields = [
              ["Price", item.product["Price"] || item.product["Variant Price"] || item.product["price"]],
              ["USP", item.product["Product USP"] || item.product["USP"] || item.product["Luxury Selling Point"]],
              ["Craft", item.product["Technique"] || item.product["Craft"]],
              ["Fabric", item.product["Fabric"]],
              ["Best for", item.product["Best For"] || item.product["Primary Occasion"] || item.product["Occasion"]]
            ];
            metaFields.forEach(function (field) {
              const value = Array.isArray(field[1]) ? field[1].filter(Boolean).join(", ") : String(field[1] || "").trim();
              if (!value) return;
              const line = document.createElement("div");
              const label = document.createElement("strong");
              label.textContent = field[0] + ": ";
              line.appendChild(label);
              line.appendChild(document.createTextNode(value));
              productMeta.appendChild(line);
            });
            if (productMeta.childNodes.length) productBox.appendChild(productMeta);

            const productId = String(
              item.product["URL"] || item.product["Product name"] || item.product["Handle"] || productName
            ).trim();
            const handle = String(item.product["Handle"] || "").trim();
            const reactions = (room.reactions || {})[productId] || {};
            const reactionBar = document.createElement("div");
            reactionBar.className = "meera-room-reactions";
            reactionBar.style.cssText = "display:flex;gap:8px;align-items:center;flex-wrap:wrap;padding:8px 10px;border-top:1px solid #eee;";

            ["👍", "👎"].forEach(function (emoji) {
              const people = reactions[emoji] || [];
              const reactionButton = document.createElement("button");
              reactionButton.type = "button";
              reactionButton.textContent = emoji + " " + people.length;
              reactionButton.title = people.length ? people.join(", ") : "React to this product";
              reactionButton.setAttribute("aria-label", emoji + " reaction, " + people.length + " votes");
              reactionButton.style.cssText = "border:1px solid #b8a77d;border-radius:22px;background:#fffaf0;padding:5px 10px;cursor:pointer;font-size:13px;touch-action:manipulation;";
              reactionButton.addEventListener("click", async function () {
                reactionButton.disabled = true;
                try {
                  const response = await fetch(MEERA_API + "/room/" + encodeURIComponent(room.code) + "/react", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ name: currentUserName, product_id: productId, emoji: emoji })
                  });
                  const updatedRoom = await response.json();
                  if (!response.ok || updatedRoom.error) throw new Error(updatedRoom.error || "Reaction failed");
                  renderRoom(updatedRoom);
                } catch (error) {
                  console.error("Shopping Room reaction error:", error);
                  reactionButton.disabled = false;
                }
              });
              reactionBar.appendChild(reactionButton);
            });

            if (handle) {
              const tryOnButton = document.createElement("button");
              tryOnButton.type = "button";
              tryOnButton.textContent = "✨ Try It On";
              tryOnButton.style.cssText = "border:1px solid #cdbb91;border-radius:18px;background:#fffaf0;padding:5px 10px;cursor:pointer;font-size:13px;";
              const photoInput = document.createElement("input");
              photoInput.type = "file";
              photoInput.accept = "image/*";
              photoInput.style.display = "none";
              tryOnButton.addEventListener("click", function () {
                if (roomFilePickerActive || tryOnButton.disabled || roomTryOnInProgress[productId]) return;
                roomTryOnInProgress[productId] = "picker";
                roomFilePickerActive = true;
                tryOnButton.disabled = true;
                tryOnButton.textContent = "Choose your photo…";
                tryOnButton.style.opacity = "0.75";
                // Trigger the native picker synchronously within the tap gesture.
                photoInput.click();
              });
              photoInput.addEventListener("change", async function () {
                const file = photoInput.files && photoInput.files[0];
                roomFilePickerActive = false;
                if (roomTryOnInProgress[productId] === "picker") {
                  delete roomTryOnInProgress[productId];
                }
                if (!file) {
                  if (tryOnButton.isConnected) tryOnButton.disabled = false;
                  renderRoom(latestRoom || roomData);
                  return;
                }
                if (!file.type.startsWith("image/") || file.size > 10 * 1024 * 1024) {
                  window.alert("Choose an image smaller than 10 MB.");
                  photoInput.value = "";
                  return;
                }
                let generatedResult = null;
                roomTryOnInProgress[productId] = "processing";
                try {
                  tryOnButton.disabled = true;
                  tryOnButton.textContent = "Creating Try On…";
                  const formData = new FormData();
                  formData.append("session_id", getSessionId());
                  formData.append("photo", file);
                  formData.append("product_handle", handle);
                  const response = await fetch(MEERA_API + "/tryon", { method: "POST", body: formData });
                  const data = await response.json();
                  if (data.error === "Shopify customer login required") {
                    window.alert("Please log in to your Kosala account to use Try It On.");
                  } else if (!response.ok || !data.ok || !data.image_base64) {
                    window.alert(data.message || data.error || "Try On could not be created right now.");
                  } else {
                    const sharedResult = {
                      name: currentUserName,
                      product_id: productId,
                      message: data.message || "",
                      image_base64: data.image_base64,
                      product_name: data.product_name || productName
                    };
                    generatedResult = sharedResult;
                    roomTryOnResults[productId] = {
                      message: sharedResult.message,
                      image_base64: sharedResult.image_base64,
                      product_name: sharedResult.product_name,
                      updated_at: Date.now()
                    };
                    renderRoom(latestRoom || room);
                    const shareResponse = await fetch(MEERA_API + "/room/" + encodeURIComponent(room.code) + "/tryon", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(sharedResult)
                    });
                    const shareData = await meeraReadResponse(shareResponse);
                    if (!shareResponse.ok || !shareData.ok) {
                      const detail = String(shareData.error || shareData.message || "").toLowerCase();
                      throw new Error(
                        detail.includes("timed out") || detail.includes("timeout")
                          ? "The Try On image was generated, but saving it to the room timed out."
                          : "The Try On image was generated, but it could not be saved to the room yet."
                      );
                    }
                    roomTryOnResults[productId] = {
                      message: sharedResult.message,
                      image_base64: sharedResult.image_base64,
                      product_name: sharedResult.product_name,
                      updated_at: shareData.result.updated_at
                    };
                    renderRoom(latestRoom || room);
                  }
                } catch (error) {
                  console.error("Shopping Room Try On error:", error);
                  if (generatedResult) {
                    roomTryOnResults[productId] = {
                      message: "Try On generated. Saving it to the room timed out; the preview is still available here.",
                      image_base64: generatedResult.image_base64,
                      product_name: generatedResult.product_name,
                      updated_at: Date.now()
                    };
                    renderRoom(latestRoom || room);
                  } else {
                    const message = String(error && error.message || "");
                    window.alert(
                      /timed out|timeout|unexpected token|not valid json/i.test(message)
                        ? "The Try On service did not respond in time. Please try once more."
                        : (message || "Try On could not be created right now. Please try again.")
                    );
                  }
                } finally {
                  delete roomTryOnInProgress[productId];
                  tryOnButton.disabled = false;
                  tryOnButton.textContent = "✨ Try It On";
                  photoInput.value = "";
                }
              });
              reactionBar.appendChild(tryOnButton);
              reactionBar.appendChild(photoInput);
            }

            const savedTryOn = roomTryOnResults[productId];
            if (savedTryOn && savedTryOn.image_base64) {
              const preview = document.createElement("div");
              preview.style.cssText = "padding:10px;border-top:1px solid #eee;width:100%;box-sizing:border-box;";
              if (savedTryOn.message) {
                const note = document.createElement("div");
                note.textContent = savedTryOn.message;
                note.style.marginBottom = "8px";
                preview.appendChild(note);
              }
              const resultImage = document.createElement("img");
              resultImage.src = "data:image/png;base64," + savedTryOn.image_base64;
              resultImage.alt = "Try-on preview for " + savedTryOn.product_name;
              resultImage.style.cssText = "display:block;width:auto;max-width:100%;height:auto;max-height:320px;object-fit:contain;object-position:left top;border-radius:8px;margin:0 auto 0 0;";
              preview.appendChild(resultImage);

              const roomStyle = document.createElement("div");
              roomStyle.style.cssText = "margin-top:10px;padding:10px;background:#f8f5ee;border:1px solid #e2ddd2;border-radius:8px;";
              const roomStyleToggle = document.createElement("button");
              roomStyleToggle.type = "button";
              roomStyleToggle.textContent = "✨ Style this look";
              roomStyleToggle.style.cssText = "display:block;width:100%;text-align:left;border:0;background:transparent;padding:4px 2px;font-weight:700;font-size:14px;cursor:pointer;color:#222;";
              const roomStyleOptions = document.createElement("div");
              roomStyleOptions.style.cssText = "display:none;flex-wrap:wrap;gap:6px;margin-top:8px;";
              const productStyleText = (productName + " " + handle).toLowerCase();
              let roomStyleChoices;
              if (productStyleText.includes("saree")) {
                roomStyleChoices = [
                  ["Blouse", "Style this same saree with a well-matched blouse. Preserve the saree's exact colour, weave, border and design."],
                  ["Pallu & Drape", "Improve the pallu and drape of this same saree. Preserve its exact colour, weave, border and design."],
                  ["Complete the Look", "Complete this saree look with coordinated jewellery and suitable footwear while preserving the saree's exact design."]
                ];
              } else if (productStyleText.includes("dupatta") || productStyleText.includes("stole")) {
                roomStyleChoices = [
                  ["Style the Drape", "Style this same dupatta or stole elegantly with a coordinated outfit. Keep its original colour, weave, border and design unchanged."],
                  ["Complete the Look", "Create a coordinated look around this same dupatta or stole, choosing suitable clothing and footwear while preserving its original design."]
                ];
              } else if (productStyleText.includes("kurta") || productStyleText.includes("men")) {
                roomStyleChoices = [
                  ["Add Nehru Jacket", "Add a complementary Nehru jacket to this same men's kurta look. Preserve the kurta's exact colour, weave and design."],
                  ["Add Stole", "Style this same men's kurta with a complementary stole. Preserve the kurta's exact colour, weave and design."],
                  ["Complete the Look", "Choose the best coordinated festive look for this same men's kurta, adding a suitable jacket or stole only if appropriate, traditional footwear and restrained accessories. Preserve the kurta's exact colour, weave and design."]
                ];
              } else {
                roomStyleChoices = [
                  ["Style the Look", "Improve the styling of this same outfit with coordinated accessories while preserving the original garment's colour and design."],
                  ["Complete the Look", "Create a coordinated complete look with suitable accessories and footwear while preserving the original garment's colour and design."]
                ];
              }
              roomStyleChoices.forEach(function (choice) {
                const choiceButton = document.createElement("button");
                choiceButton.type = "button";
                choiceButton.textContent = choice[0];
                choiceButton.style.cssText = "border:1px solid #b8a77d;border-radius:7px;background:#fff;padding:7px 9px;font-size:12px;cursor:pointer;";
                choiceButton.addEventListener("click", async function () {
                  if (roomStyleRequestActive) return;
                  roomStyleRequestActive = true;
                  choiceButton.disabled = true;
                  choiceButton.textContent = "Styling…";
                  try {
                    const latestBlob = await base64ImageToBlobInChunks(savedTryOn.image_base64, 1024 * 1024);
                    const styleForm = new FormData();
                    styleForm.append("session_id", getSessionId());
                    styleForm.append("photo", latestBlob, "meera-room-latest-tryon.png");
                    styleForm.append("product_handle", handle);
                    styleForm.append("notes", choice[1]);
                    const styleResponse = await fetch(MEERA_API + "/tryon", { method: "POST", body: styleForm });
                    const styleData = await styleResponse.json();
                    if (styleData.error === "Shopify customer login required") {
                      window.alert("Please log in to your Kosala account to use Try It On.");
                      return;
                    }
                    if (!styleResponse.ok || !styleData.ok || !styleData.image_base64) {
                      throw new Error(styleData.message || styleData.error || "Could not style this look.");
                    }
                    const nextShared = {
                      name: currentUserName,
                      product_id: productId,
                      message: styleData.message || "",
                      image_base64: styleData.image_base64,
                      product_name: styleData.product_name || productName
                    };
                    roomTryOnResults[productId] = {
                      message: nextShared.message,
                      image_base64: nextShared.image_base64,
                      product_name: nextShared.product_name,
                      updated_at: Date.now()
                    };
                    renderRoom(latestRoom || room);
                    try {
                      const shareResponse = await fetch(MEERA_API + "/room/" + encodeURIComponent(room.code) + "/tryon", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(nextShared)
                      });
                      const shareData = await meeraReadResponse(shareResponse);
                      if (!shareResponse.ok || !shareData.ok) {
                        throw new Error("The styled image was generated, but saving it to the room failed.");
                      }
                      roomTryOnResults[productId].updated_at = shareData.result.updated_at;
                    } catch (shareError) {
                      console.error("Styled Try On sharing error:", shareError);
                      roomTryOnResults[productId].message = "Styled image generated, but sharing with the room failed.";
                    }
                  } catch (styleError) {
                    console.error("Shopping Room style error:", styleError);
                    window.alert(styleError.message || "Could not style this look right now.");
                  } finally {
                    roomStyleRequestActive = false;
                    renderRoom(latestRoom || room);
                  }
                });
                roomStyleOptions.appendChild(choiceButton);
              });
              roomStyleToggle.addEventListener("click", function () {
                const open = roomStyleOptions.style.display === "flex";
                roomStyleOptions.style.display = open ? "none" : "flex";
                roomStyleToggle.setAttribute("aria-expanded", String(!open));
              });
              roomStyle.appendChild(roomStyleToggle);
              roomStyle.appendChild(roomStyleOptions);
              preview.appendChild(roomStyle);
              productBox.appendChild(preview);
            }

            const reactionNames = document.createElement("div");
            reactionNames.style.cssText = "width:100%;font-size:11px;color:#666;";
            const likedBy = reactions["👍"] || [];
            const dislikedBy = reactions["👎"] || [];
            const nameGroups = [];
            if (likedBy.length) nameGroups.push("👍 " + likedBy.join(", "));
            if (dislikedBy.length) nameGroups.push("👎 " + dislikedBy.join(", "));
            reactionNames.textContent = nameGroups.join(" · ") || "No reactions yet";
            reactionBar.appendChild(reactionNames);
            productBox.appendChild(reactionBar);
            message.appendChild(productBox);
          }

          transcript.appendChild(message);
        });

        if (wasNearBottom) {
          transcript.scrollTop = transcript.scrollHeight;
        } else {
          transcript.scrollTop = previousScrollTop;
        }
      }

      window.addEventListener("focus", function onRoomPickerReturn() {
        // Mobile browsers can fire focus before the file input's change event.
        // Wait briefly so selecting a photo is not mistaken for cancelling the picker.
        window.setTimeout(function () {
          if (roomFilePickerActive) {
            const pickerInput = shoppingRoom.querySelector('input[type="file"]');
            if (pickerInput && pickerInput.files && pickerInput.files.length) return;
            roomFilePickerActive = false;
            renderRoom(latestRoom || roomData);
          }
        }, 900);
      });
      renderRoom(roomData);
      let roomPolling = setInterval(async function () {
        try {
          const response = await fetch(
            MEERA_API + "/room/" + encodeURIComponent(roomData.code)
          );

          if (!response.ok) {
            return;
          }

          const updatedRoom = await response.json();

          if (updatedRoom.error) {
            return;
          }

          renderRoom(updatedRoom);

        } catch (error) {
          console.error("Shopping Room refresh error:", error);
        }
      }, 2000);

      shoppingRoom
        .querySelector("#meera-shopping-room-copy-code")
        .addEventListener("click", async function () {
          const copyButton = this;
          const code = String(roomData.code || "").trim();
          if (!code) return;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code);
            } else {
              const temporaryInput = document.createElement("textarea");
              temporaryInput.value = code;
              temporaryInput.style.position = "fixed";
              temporaryInput.style.opacity = "0";
              document.body.appendChild(temporaryInput);
              temporaryInput.select();
              const copied = document.execCommand("copy");
              temporaryInput.remove();
              if (!copied) throw new Error("Copy was not available");
            }
            copyButton.textContent = "Copied!";
            setTimeout(function () { copyButton.textContent = "Copy code"; }, 1600);
          } catch (error) {
            window.prompt("Copy this room code:", code);
          }
        });

      function returnToPrivateMeera() {
        clearInterval(roomPolling);
        shoppingRoom.remove();
        localStorage.removeItem("meera_room_code");
        localStorage.removeItem("meera_room_name");
        // Keep Meera's private session ID and conversation history intact.
      }

      const roomMaximizeButton = shoppingRoom.querySelector("#meera-shopping-room-maximize");
      roomMaximizeButton.addEventListener("click", function () {
        const isMaximized = shoppingRoom.classList.toggle("meera-room-maximized");
        roomMaximizeButton.textContent = isMaximized ? "⛶ Restore" : "⛶ Maximize";
        roomMaximizeButton.setAttribute("aria-label", isMaximized ? "Restore Shopping Room" : "Maximize Shopping Room");
        roomMaximizeButton.title = isMaximized ? "Restore Shopping Room" : "Maximize Shopping Room";
      });

      shoppingRoom
        .querySelector("#meera-shopping-room-back")
        .addEventListener("click", returnToPrivateMeera);

      shoppingRoom
        .querySelector("#meera-shopping-room-close")
        .addEventListener("click", returnToPrivateMeera);
      sendButton.addEventListener("click", async function () {

        const text = messageInput.value.trim();

        if (!text) {
          return;
        }

        sendButton.disabled = true;
        sendButton.textContent = "Sending...";

        try {

          const response = await fetch(
            MEERA_API +
              "/room/" +
              encodeURIComponent(roomData.code) +
              "/message",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                name: currentUserName,
                message: text,
                ask_meera: askMeera.checked
              })
            }
          );

          const updatedRoom = await response.json();

          if (!response.ok || updatedRoom.error) {
            throw new Error(
              updatedRoom.message ||
              updatedRoom.error ||
              "Could not send the message."
            );
          }

          renderRoom(updatedRoom);

          messageInput.value = "";

        } catch (error) {

          console.error("Shopping Room message error:", error);

          alert(
            error.message ||
            "Something went wrong while sending the message."
          );

        } finally {

          sendButton.disabled = false;
          sendButton.textContent = "Send";

        }
      });

      messageInput.dataset.name = currentUserName || "Guest";

      messageInput.addEventListener("keydown", function (event) {

        if (
          event.key === "Enter" &&
          !event.shiftKey
        ) {
          event.preventDefault();
          sendButton.click();
        }

      });
    }
    const savedRoomCode = localStorage.getItem("meera_room_code");
    const savedRoomName = localStorage.getItem("meera_room_name");

    if (savedRoomCode && savedRoomName) {
      fetch(
        MEERA_API + "/room/" + encodeURIComponent(savedRoomCode)
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (roomData) {
          if (!roomData.error) {
            openShoppingRoom(roomData, savedRoomName);
          } else {
            localStorage.removeItem("meera_room_code");
            localStorage.removeItem("meera_room_name");
          }
        })
        .catch(function (error) {
          console.error("Could not restore Shopping Room:", error);
        });
    }
    send.addEventListener("click", sendMessage);

    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        sendMessage();
      }
    });

    const logoutSessionToClear = sessionStorage.getItem("meera_logout_pending");
    if (logoutSessionToClear) {
      localStorage.removeItem("meera_chat_history_" + logoutSessionToClear);
      localStorage.removeItem(CHAT_HISTORY_KEY);
      sessionStorage.removeItem("meera_logout_pending");
      messages.replaceChildren();
      addMessage("Hi, I'm Meera. What are you looking for today?", "assistant");
      saveChatHistory();
    } else if (!restoreChatHistory()) {
      addMessage(
        "Hi, I'm Meera. What are you looking for today?",
        "assistant"
      );
    }

    // ------------------------------------------------------------------
    // MEERA UX v2: layout, mobile sheet, quick replies, product carousel
    // ------------------------------------------------------------------
    (function meeraUxV2() {
      const css = `
        /* layout: header / messages / chips / input stacked, no magic heights */
        #meera-widget-panel { z-index: 2147483000; }
        #meera-widget-panel[style*="display: block"] {
          display: flex !important;
          flex-direction: column;
        }
        #meera-widget-header {
          flex: 0 0 auto;
          min-height: 56px;
          padding: 8px 12px !important;
          box-sizing: border-box;
          gap: 8px;
        }
        #meera-widget-header .meera-header-left { min-width: 0; gap: 10px; }
        #meera-widget-header strong { font-size: 16px; line-height: 1.15; display: block; }
        .meera-header-sub { display: block; font-size: 11px; font-weight: 400; opacity: .75; }
        #meera-widget-header > div:last-child {
          display: flex; align-items: center; gap: 8px; flex: 0 0 auto;
        }
        #meera-widget-fit {
          height: 36px; padding: 0 14px; border-radius: 18px; border: 0;
          background: #fff; color: #222; font-size: 13px; font-weight: 700; cursor: pointer;
        }
        #meera-widget-room, #meera-widget-maximize {
          width: 36px; height: 36px; padding: 0; margin: 0 !important; border: 0;
          border-radius: 50%; background: rgba(255,255,255,.75) !important;
          color: #222 !important; font-size: 16px; line-height: 1;
          display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
        }
        #meera-widget-close {
          width: 36px; height: 36px; padding: 0; border: 0; border-radius: 50%;
          background: #222 !important; color: #fff !important;
          font-size: 24px; line-height: 1; cursor: pointer;
          display: inline-flex; align-items: center; justify-content: center;
        }
        #meera-widget-messages {
          flex: 1 1 auto; height: auto !important; min-height: 0;
          overflow-y: auto; -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain; padding: 12px !important;
        }
        .meera-user span, .meera-assistant span { max-width: 88% !important; }
        #meera-chips {
          flex: 0 0 auto; display: flex; gap: 8px; overflow-x: auto;
          padding: 8px 10px 4px; background: #fff; border-top: 1px solid #eee;
          scrollbar-width: none; -webkit-overflow-scrolling: touch;
        }
        #meera-chips::-webkit-scrollbar { display: none; }
        #meera-chips button {
          flex: 0 0 auto; white-space: nowrap; min-height: 34px; cursor: pointer;
          padding: 6px 12px; border-radius: 17px; font-size: 13px; color: #222;
          border: 1px solid #d8c28f; background: #fffaf0;
        }
        #meera-chips button:active { background: #f3e8cc; }
        #meera-widget-input-area {
          position: static !important; height: auto !important; flex: 0 0 auto;
          align-items: center; box-sizing: border-box;
          padding: 8px 10px calc(8px + env(safe-area-inset-bottom)) !important;
          border-top: 0 !important; background: #fff;
        }
        #meera-widget-input { height: 44px; font-size: 16px !important; }
        #meera-widget-send { height: 44px; width: 72px; font-weight: 600; }

        /* products: swipeable carousel with the FULL photo visible */
        #meera-widget-panel:not(.meera-maximized) .meera-products {
          flex-direction: row; overflow-x: auto; gap: 10px;
          scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch;
          margin: 10px -12px 0; padding: 0 12px 8px;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product {
          flex: 0 0 78%; max-width: 300px; scroll-snap-align: center;
          display: flex; flex-direction: column;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product > img {
          width: 100%; height: auto; max-height: none;
          aspect-ratio: 4 / 5; object-fit: contain; background: #f7f4ed;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product-body {
          padding: 10px 12px 12px; display: flex; flex-wrap: wrap;
          gap: 8px; align-items: center;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product-name {
          flex: 1 1 100%; margin: 0; font-size: 14px; line-height: 1.3;
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
          overflow: hidden;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product-price {
          flex: 1 1 100%; margin: 0; font-size: 16px; font-weight: 700;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-product-link {
          flex: 1 1 0; min-height: 40px; box-sizing: border-box;
          display: inline-flex; align-items: center; justify-content: center;
          background: #222; color: #fff !important; border: 0 !important;
          border-radius: 8px; font-size: 13px; font-weight: 600; padding: 0 8px;
        }
        #meera-widget-panel:not(.meera-maximized) .meera-tryon-button {
          flex: 1 1 0; margin: 0 !important; min-height: 40px;
          border-radius: 8px !important; font-size: 13px !important; padding: 0 8px !important;
        }

        /* phones: full-screen sheet above every other floating widget */
        @media (max-width: 600px) {
          #meera-widget-panel {
            position: fixed !important; top: 0; left: 0 !important; right: 0 !important;
            bottom: auto; width: 100vw !important; max-width: none !important;
            height: 100dvh; max-height: none !important;
            border-radius: 0 !important; border: 0 !important;
          }
          #meera-widget-maximize { display: none !important; }
          body.meera-open { overflow: hidden !important; }
        }
      `;
      const style = document.createElement("style");
      style.id = "meera-ux-v2";
      style.textContent = css;
      document.body.appendChild(style);

      // Header: add a small subtitle under the name.
      const strong = document.querySelector("#meera-widget-header .meera-header-left strong");
      if (strong && !strong.parentNode.classList.contains("meera-header-title")) {
        const wrap = document.createElement("div");
        wrap.className = "meera-header-title";
        strong.parentNode.insertBefore(wrap, strong);
        wrap.appendChild(strong);
        const sub = document.createElement("span");
        sub.className = "meera-header-sub";
        sub.textContent = "Your handloom stylist";
        wrap.appendChild(sub);
      }
      close.setAttribute("aria-label", "Close chat");

      // Quick-reply chips
      const chips = document.createElement("div");
      chips.id = "meera-chips";
      panel.insertBefore(chips, document.getElementById("meera-widget-input-area"));

      const START = [
        ["\u{1F389} Wedding", "Show me a saree for a wedding"],
        ["\u{1FA94} Diwali", "What should I wear for Diwali?"],
        ["\u{1F4BC} Office", "I need something for office"],
        ["\u{1F33C} Haldi / Mehendi", "Something for a haldi ceremony"],
        ["☀️ Hot weather", "Suggest something light for hot weather"],
        ["\u{1F381} Gift", "I want to buy a gift"],
        ["✨ Surprise me", "Surprise me"],
        ["\u{1F9F5} Genuine Kosa?", "How do I know it is genuine Kosa silk?"],
        ["↩️ Returns", "What is your return policy?"]
      ];
      const AFTER = [
        ["Another one", "Show me another"],
        ["Darker", "Something darker"],
        ["Lighter", "Something lighter"],
        ["How to style", "How to style this"],
        ["Real silk?", "Is this real silk?"],
        ["Care tips", "How do I care for this?"],
        ["Returns", "What is your return policy?"]
      ];
      function setChips(list) {
        chips.replaceChildren();
        list.forEach(function (item) {
          const b = document.createElement("button");
          b.type = "button";
          b.textContent = item[0];
          b.addEventListener("click", function () {
            if (send.disabled) return;
            input.value = item[1];
            send.click();
          });
          chips.appendChild(b);
        });
        chips.scrollLeft = 0;
      }
      setChips(START);
      new MutationObserver(function (records) {
        records.forEach(function (r) {
          r.addedNodes.forEach(function (n) {
            if (n.nodeType === 1 && n.classList && n.classList.contains("meera-products")) {
              setChips(AFTER);
            }
          });
        });
      }).observe(messages, { childList: true });
      if (messages.querySelector(".meera-products")) setChips(AFTER);

      // Phone behaviour: lift the panel to <body> so nothing in the theme
      // (sticky header, WhatsApp bubble, currency picker, cookie bar) can sit
      // on top of it; lock page scroll while open.
      // Desktop: also lift the panel out of the (stacking-context) header so the
      // WhatsApp bubble / cookie bar cannot overlap the Send button; keep it
      // anchored under the "Ask Meera" button.
      function placeDesktopPanel() {
        if (meeraIsMobile() || panel.style.display === "none") return;
        if (panel.classList.contains("meera-maximized")) {
          panel.style.position = ""; panel.style.top = ""; panel.style.right = "";
          return;
        }
        const r = button.getBoundingClientRect();
        panel.style.position = "fixed";
        panel.style.top = Math.max(8, Math.round(r.bottom + 8)) + "px";
        panel.style.right = Math.max(12, Math.round(window.innerWidth - r.right)) + "px";
      }
      button.addEventListener("click", function () {
        if (panel.parentNode !== document.body) document.body.appendChild(panel);
        if (meeraIsMobile()) {
          document.body.classList.add("meera-open");
          fitPanelToVisibleViewport();
        } else {
          placeDesktopPanel();
        }
      });
      maximize.addEventListener("click", function () { window.setTimeout(placeDesktopPanel, 0); });
      window.addEventListener("resize", placeDesktopPanel);
      close.addEventListener("click", function () {
        document.body.classList.remove("meera-open");
      });
      window.addEventListener("resize", fitPanelToVisibleViewport);
    })();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createWidget);
  } else {
    createWidget();
  }
})();
